<template>
  <div class="mt-5 px-lg-5 mx-md-2">
    <v-container v-if="editLoader" type="image" class="loding">
      <v-skeleton-loader type="image"></v-skeleton-loader>
      <v-skeleton-loader type="image"></v-skeleton-loader>
    </v-container>

    <div v-else class="modal-test my-5 mx-3 bg-color p-5">
      <div class=" ">
        <div class="d-flex justify-content-between mb-5">
          <div class="d-flex align-items-center">
            <v-chip
              class="py-3 px-4 brouillon  status-badge status-readonly"
              :style="getStatusBadgeStyle()"
            >
              {{ getDisplayStatusText() }}
            </v-chip>
          </div>
          <div>
            <b-dropdown
              size="lg"
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
              class="custom-dropdown"
            >
              <template #button-content style="box-shadow: none !important">
                <span style="color: black; font-size: 24px">&#x22EE;</span>
                <span class="sr-only">Menu</span>
              </template>
              <b-dropdown-item
                v-if="
                  isSuperAdmin ||
                  isentrepriseAdmin ||
                  isAssistant ||
                  isCommercial
                "
                @click="generate()"
                >{{ $t("Telecharger") }} {{ $t("Devis") }}</b-dropdown-item
              >
              <b-dropdown-item
                v-if="!hasFactureNumber"
                @click="facture()"
                >{{ $t("facture") }}</b-dropdown-item
              >
              <b-dropdown-item
                v-if="hasFactureNumber"
                @click="generateFacture()"
                >{{ $t("Telecharger") }} {{ $t("facture") }}
              </b-dropdown-item>
            <b-dropdown-item
              v-if="isAcompteFacture"
              @click="convertAcompteToFinal"
            >
              {{  "Convertir en facture finale" }}
            </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  isSuperAdmin ||
                  isentrepriseAdmin ||
                  isAssistant ||
                  isCommercial
                "
                @click="sendEmail()"
              >
                {{ $t("SEND_BY_EMAIL") }}</b-dropdown-item
              >
              <b-dropdown-item
                v-if="
                  (isSuperAdmin ||
                    isentrepriseAdmin ||
                    isAssistant ||
                    isCommercial) &&
                  devisObject.data.brouillon === 0
                "
                @click="signed()"
                >{{ $t("YOUSIGN") }}</b-dropdown-item
              >
              <b-dropdown-item
                v-if="
                  isSuperAdmin ||
                  isentrepriseAdmin ||
                  isAssistant ||
                  isCommercial
                "
                @click="downloadEntreprisesPdf()"
                >{{  "Liste des entreprises effectué les travaux" }}</b-dropdown-item
              >
            </b-dropdown>
            <b-button
              variant="success"
              @click="handleUpdate()"
              v-if="
                (isSuperAdmin || isentrepriseAdmin || isAssistant || isCommercial) &&
                !(documentType === 'devis' && hasFactureNumber)
              "
            >
              {{ $t("EDIT") }}
              <div v-if="editLoader" class="loading ml-2">
                <div class="spinner-border" role="status"></div>
              </div>
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="devisObject.data?.devis" class="modal-test">
        <div class="">
          <div class="part">
            <div class="container-fluid mb-3">
              <div class="row">
                <!-- Logo or Initials -->
                <div class="col-md-3 col-sm-12 mb-3">
                  <div
                    v-if="!devisObject?.data?.devis?.entreprise?.logo"
                    class="text-center"
                  >
                    <div
                      v-if="devisObject?.data?.devis?.entreprise?.lib"
                      class="profil-placeholder"
                    >
                      <div class="colorWhite">
                        {{
                          devisObject?.data?.devis?.entreprise?.lib.slice(0, 2)
                        }}
                      </div>
                    </div>
                  </div>

                  <img
                    v-else
                    class="img-fluid wImag"
                    :src="
                      downloadUrl + devisObject?.data?.devis?.entreprise?.logo
                    "
                    alt="Entreprise Logo"
                  />
                </div>

                <!-- Entreprise Details -->
                <div class="col-md-5 col-sm-12 mb-3">
                  <div>
                    <b v-if="devisObject.data?.devis?.entreprise?.lib">{{ devisObject.data?.devis?.entreprise?.lib }}</b>
                    <div>
                      <span v-if=" devisObject.data?.devis?.entreprise?.rue">{{ devisObject.data?.devis?.entreprise?.rue }}</span
                      >,
                      <span v-if="devisObject.data?.devis?.entreprise?.cp">{{ devisObject.data?.devis?.entreprise?.cp }}</span
                      >,
                      <span v-if="devisObject.data?.devis?.entreprise?.ville">{{
                        devisObject.data?.devis?.entreprise?.ville
                      }}</span>
                    </div>
                    <div v-if="devisObject.data?.devis?.entreprise?.num_tva">
                      {{ $t("SIRET") }}:
                      {{ devisObject.data?.devis?.entreprise?.siret }}
                    </div>
                    <div v-if="devisObject.data?.devis?.entreprise?.num_tva">
                      {{ $t("N° TVA") }}:
                      {{ devisObject.data?.devis?.entreprise?.num_tva }}
                    </div>
                    <div v-if="devisObject.data?.devis?.entreprise?.phone?.formated_phone">
                      {{ $t("N°Téléphone") }}:
                      {{
                        devisObject.data?.devis?.entreprise?.phone
                          ?.formated_phone
                      }}
                    </div>
                  </div>
                </div>

                <!-- Client Details -->
                <div class="col-md-4 col-sm-12">
                  <ul>
                    <div v-if="devisObject.data?.devis?.client?.raison_sociale">
                      <b>{{ devisObject.data?.devis?.client?.raison_sociale }}</b>
                    </div>
                    <div v-if="devisObject.data?.devis?.client?.nom || devisObject.data?.devis?.client?.prenom">
                      <span>
                        <b>{{ devisObject.data?.devis?.client?.nom }} {{ devisObject.data?.devis?.client?.prenom }}</b>
                      </span>
                    </div>
                    <li v-if="devisObject.data?.devis?.client?.rue">{{ devisObject.data?.devis?.client?.rue }}</li>
                    <li v-if="devisObject.data?.devis?.client?.cp || devisObject.data?.devis?.client?.ville">
                      {{ devisObject.data?.devis?.client?.cp }}
                      {{ devisObject.data?.devis?.client?.ville }}
                    </li>
                    <li v-if="devisObject.data?.devis?.client?.phone?.phone_number || devisObject.data?.devis?.client?.tel_fixe || devisObject.data?.devis?.client?.company_phone">
                      {{ $t("TEL") }}:
                      <span v-if="devisObject.data?.devis?.client?.phone?.phone_number">
                        {{ devisObject.data.devis?.client?.phone?.prefix }}
                        {{ devisObject.data.devis?.client?.phone?.phone_number }}
                      </span>
                      <span v-if="devisObject.data?.devis?.client?.tel_fixe">
                        <template v-if="devisObject.data?.devis?.client?.phone?.phone_number"> / </template>
                        {{ formatPhoneFixe(devisObject.data.devis?.client?.tel_fixe) }}
                      </span>
                      <span v-else-if="devisObject.data?.devis?.client?.company_phone">
                        <template v-if="devisObject.data?.devis?.client?.phone?.phone_number"> / </template>
                        {{ devisObject.data.devis?.client?.company_phone.formated_phone }}
                      </span>
                    </li>
                    <li v-if="devisObject.data?.devis?.client?.company_email || devisObject.data?.devis?.client?.email">
                      {{ $t("EMAIL") }}:
                      {{ devisObject.data?.devis?.client?.company_email || devisObject.data?.devis?.client?.email }}
                    </li>
                    <li v-if="devisObject.data?.devis?.client?.siret">
                      {{ $t("SIRET") }}: {{ devisObject.data?.devis?.client?.siret }}
                    </li>
                    <li v-if="devisObject.data?.devis?.client?.zone">
                      {{ $t("ZONE") }}: {{ devisObject.data?.devis?.client?.zone }}
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Additional Information -->
              <div class="row">
                <div class="col-12">
                  <div v-if="!isDevisLibre">
                    <div v-if="devisObject.data?.devis?.logement?.type_chauffage">
                      {{ $t("TYPE_CHAUFFAGE") }}:
                      {{ devisObject.data?.devis?.logement?.type_chauffage }}
                    </div>
                    <div v-if="devisObject.data?.devis?.logement?.type">
                      {{ $t("TYPE_LOGEMENT") }}:
                      {{ devisObject.data?.devis?.logement?.type }}
                    </div>
                    <div>
                      <span v-if="devisObject.data?.devis?.logement?.periode_de_construction"
                        >/{{
                          devisObject.data?.devis?.logement
                            ?.periode_de_construction
                        }}</span
                      >

                      <span v-if="devisObject.data?.devis?.logement?.surface"
                        >/{{
                          devisObject.data?.devis?.logement?.surface
                        }}
                        m²</span
                      >
                    </div>
                    <div v-if="devisObject.data.devis?.logement?.parcelle_cadastrale">
                      {{ $t("CADASTRAL_PARCEL") }}:
                      {{
                        devisObject.data.devis?.logement?.parcelle_cadastrale
                      }}
                    </div>
                  </div>
                    <div v-if="  devisObject.data?.devis" class="mt-2">
                      <b v-if="devisObject.data?.devis?.contact_sur_site ">
                      Contact sur site   {{devisObject.data?.devis?.contact_sur_site }}
                      </b>
                      <span v-if=" devisObject.data?.devis?.telephone_contact"> - </span>
                      <b v-if="devisObject.data?.devis?.telephone_contact">
                        {{ devisObject.data?.devis?.telephone_contact.phone_number }}
                      </b>
                    </div>
                  <div class="mt-3" >
                    <b v-if=" devisObject.data?.devis?.logement?.adresse">{{ $t("Adresse des travaux") }}:</b>
                    <div>
                      {{ devisObject.data?.devis?.logement?.adresse }}
                      <span v-if="devisObject.data?.devis?.logement?.code_postal || devisObject.data?.devis?.logement?.ville">, </span>
                      <span v-if="devisObject.data?.devis?.logement?.code_postal">{{ devisObject.data?.devis?.logement?.code_postal }}</span>
                      <span v-if="devisObject.data?.devis?.logement?.code_postal && devisObject.data?.devis?.logement?.ville"> </span>
                      <span v-if="devisObject.data?.devis?.logement?.ville">{{ devisObject.data?.devis?.logement?.ville }}</span>
                    </div>
                  
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h5 class="my-3" >
            {{ documentLabel }}: {{ documentNumber }}
          </h5>
          <!-- <h5 class="my-3" v-if="isFactureDocument && devisNumberValue">
            {{ $t("DEVIS") }}: {{ devisNumberValue }}
          </h5> -->
          <div class="d-flex" v-if="shouldShowVisiteTechnique && !isDevisLibre">
            <span class="">{{ $t("DATE_VISITE_TECHNIQUE") }}:</span>
            <span>
              {{ formatDate(devisObject.data?.devis?.visite_technique) }}</span
            >
          </div>
      
          <div class="d-flex" v-if="shouldShowDevisDates && devisNumberValue && !isDevisLibre">
            <span class="">{{ $t("Date de signature") }}:</span>
            <span>
              {{ formatDate(devisObject.data?.devis?.fin_travaux) }}
            </span>
          </div>
          
          <div class="d-flex" v-if="shouldShowFactureDates">
            <span class="">{{ $t("Date de début de travaux") }}:</span>
            <span>
              {{ formatDate(devisObject.data?.devis?.debut_travaux) }}
            </span>
          </div>
          
          <div class="d-flex" v-if="shouldShowFactureDates">
            <span class="">{{ $t("Date de fin de travaux") }}:</span>
            <span>
              {{ formatDate(devisObject.data?.devis?.fin_travaux) }}
            </span>
          </div>
      
        </div>

        <div class="part mt-2 bg-color-gray">
          <div>
            <div class="part">
              <div
                class=""
                v-if="devisObject.data?.devis.type_devis === renovation"
              >
                <div class="">
                  <div
                    class="piece"
                    v-if="
                      devisObject.data?.devis?.logement?.type ==
                      'Maison individuelle'
                    "
                  >
                    Rénovation d’ampleur d’une maison individuelle
                  </div>
                  <div class="piece" v-else>
                   Rénovation d’ampleur d’un appartement
                  </div>
                  <div class="mx-4 mt-2">
                    <div
                      v-if="
                        devisObject.data?.devis?.logement?.type ==
                        'Maison individuelle'
                      "
                    >
                      Rénovation thermique d’ampleur d’une maison individuelle
                      existante.
                    </div>
                    <div v-else>
                      Rénovation thermique d’ampleur d’un appartement existant.
                    </div>
                    <div>
                      Le bnénéficiaire est une personne physique :<b>
                        {{
                          devisObject.data.devis
                            ?.renovation_ampleur_individuelle
                            ?.personne_physique === 1
                            ? "Oui"
                            : "Non"
                        }}</b
                      >
                    </div>
                    <div>
                      Les travaux correspondent à la seconde étape de travaux
                      :<b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.seconde_etape === 1
                          ? "Oui"
                          : "Non"
                      }}</b>
                    </div>
                    <div>
                      Surface habitable de la maison avant travaux Shab (m²) :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.surface_habitable
                      }}</b>
                    </div>
                    <div>
                      Caractéristiques du bâtiment données par l’audit
                      énergétique :
                    </div>
                    <div>
                      Consommation conventionnelle en énergie primaire avant les
                      travaux de rénovation : Cep initial (kWh/m².an) :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.cep_initial
                      }}</b>
                    </div>
                    <div>
                      Consommation conventionnelle en énergie primaire après les
                      travaux de rénovation : Cep projet (kWh/m².an) :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.cep_projet
                      }}</b>
                    </div>
                    <div>
                      Consommation conventionnelle en énergie finale avant les
                      travaux de rénovation : Cef initial (kWh/m².an) :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.cef_initial
                      }}</b>
                    </div>
                    <div>
                      Consommation conventionnelle en énergie finale après les
                      travaux de rénovation : Cef projet (kWh/m².an) :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.cef_projet
                      }}</b>
                    </div>
                    <div>
                      Classe avant les travaux de rénovation :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.classe_avant_travaux
                      }}</b>
                    </div>
                    <div>
                      Classe après les travaux de rénovation :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.classe_apres_travaux
                      }}</b>
                    </div>
                    <div>
                      Les travaux mis en œuvre correspondent à l'un des
                      scénarios proposés par l'audit énergétique:<b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.correspondent_scénarios === 1
                          ? "Oui"
                          : "Non"
                      }}</b>
                    </div>
                    <div>
                      Le bâtiment présente une contrainte technique :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.presente_contrainte === 1
                          ? "Oui"
                          : "Non"
                      }}</b>
                    </div>
                    <div>
                      Les travaux de rénovation comprennent au moins deux postes
                      de travaux :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.comprennent_au_moins_deux_postes === 1
                          ? "Oui"
                          : "Non"
                      }}</b>
                    </div>
                    <div>
                      Dans le cas d’isolants bio-sourcés la résistance thermique
                      est calculée conformément aux dispositions prévues dans
                      l’annexe IX de l’arrêté du 26 octobre 2010 :
                      <b
                        >{{
                          devisObject.data.devis
                            ?.renovation_ampleur_individuelle
                            ?.calcul_resistance_conforme === 1
                            ? "Oui"
                            : "Non"
                        }}
                      </b>
                    </div>
                    <div>
                      Il est installé un système de chauffage ou de production
                      d'eau chaude sanitaire :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.systeme_installer === 1
                          ? "Oui"
                          : "Non"
                      }}</b>
                    </div>
                    <div>
                      Il est conservé un système de chauffage ou de production
                      d'eau chaude sanitaire :
                      <b>
                        {{
                          devisObject.data.devis
                            ?.renovation_ampleur_individuelle
                            ?.systeme_concerver === 1
                            ? "Oui"
                            : "Non"
                        }}</b
                      >
                    </div>
                    <div>
                      Les émissions de gaz à effet de serre après rénovation :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.emissions_gaz === 1
                          ? "Oui"
                          : "Non"
                      }}</b>
                    </div>
                    <div>
                      Les opérations basées sur un audit :
                      <b>{{
                        devisObject.data.devis?.renovation_ampleur_individuelle
                          ?.basees_sur_audit === 1
                          ? "Oui"
                          : "Non"
                      }}</b>
                    </div>
                  </div>
                </div>

                <div class="mx-4">
                  Cumac : <b>{{ group?.cumac }} kWh</b>
                </div>
              </div>
              <div
                class="part"
                v-for="(group, index) in devisObject.data.groupeLigneDocument"
                :key="index"
              >
                <div
                  style="overflow-x: auto"
                  v-if="group.products && group.products.length > 0"
                >
                  <div class="" v-if="group.type_group === 'BAR-EN-103'">
                    <div class="">
                      <div class="piece">
                      Isolation d’un plancher
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’un procédé d’isolation sur/sous un
                        plancher bas situé entre un volume chauffé et un
                        sous-sol non chauffé, un vide sanitaire ou un passage
                        ouvert. Un procédé d'isolation est constitué de
                        l'association d'un matériau isolant et de dispositifs de
                        fixation et de protection (tels que des revêtements,
                        parements, membranes continues si nécessaire) contre des
                        dégradations liées à son exposition aux environnements
                        extérieurs et intérieurs (telles que le rayonnement
                        solaire, le vent, la pluie, la neige, les chocs,
                        l'humidité, le feu).

                        <div>Caractéristiques de l'isolant posé:</div>

                        <div>
                          Surface d’isolant posé:
                          <b
                            >{{
                              devisObject.data.devis?.isolation_plancher
                                ?.Surface_isolant
                            }}
                            m²</b
                          >
                        </div>
                        <div>
                          Résistance thermique:
                          <b
                            >{{
                              devisObject.data.devis?.isolation_plancher
                                ?.resistance_thermique
                            }}
                            m².K/W</b
                          >
                        </div>
                        <div>
                          Épaisseur:
                          <b
                            >{{
                              devisObject.data.devis?.isolation_plancher
                                ?.epaisseur
                            }}
                            mm</b
                          >
                        </div>
                        <div>
                          <div>
                            Type d’isolant :

                              <b>{{
                                formatTypeIsolant(
                                  devisObject.data.devis?.isolation_plancher
                                    ?.type_isolant
                                )
                              }}</b>
                          </div>
                          <div>
                            La résistance thermique est évaluée selon la norme
                            <b>{{
                              devisObject.data?.devis?.isolation_plancher?.norme
                            }}</b><template v-if="devisObject.data?.devis?.isolation_plancher?.norme2"> et <b>{{
                              devisObject.data?.devis?.isolation_plancher?.norme2
                            }}</b></template>
                          </div>
                        </div>
                        <div
                          v-if="
                            devisObject.data?.devis?.isolation_plancher
                              ?.necessite_pare_vapeur === 1
                          "
                        >
                          L’isolation thermique réalisée a nécessité la mise en
                          place d’un pare-vapeur ou tout autre dispositif
                          permettant d'atteindre un résultat équivalent
                        </div>
                        <div
                          v-for="(chantierItem, index) in group.products"
                          :key="index"
                        >
                          <div>
                            <div v-if="chantierItem.type_ligne === 'Product'">
                              <div>
                                Marque :
                                {{ chantierItem.fabricant }}
                              </div>
                              <div>
                                Réf :
                                {{ chantierItem.ref }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="my-2 mx-4">
                        <div class="" v-if="group?.sous_traitant !== null">
                          Traveaux sous-traités auprès de l'entreprise
                          <b> {{ group?.sous_traitant?.name }}</b>
                        </div>
                        <div v-else class="">
                          Matériel(s) fourni(s) et mis en place par notre
                          société
                          <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                        </div>
                        <div class="" v-if="group.sous_traitant !== null">
                          représentée par
                          {{ group.sous_traitant?.name }}
                          , SIRET
                          <b>
                            {{ group.sous_traitant?.num_siret }}
                            ,</b
                          >
                          Certificat rge
                        </div>
                        <div v-else class="">
                          représentée par
                          {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                          <b>
                            {{ devisObject.data.devis.entreprise?.siret }}
                            ,</b
                          >
                          Certificat rge
                        </div>
                        <div class="">
                          Numéro
                          <b> {{ group.selected_certificat_RGE?.num }} </b>
                          attribué le
                          <b>
                            {{
                              formatDate(
                                group.selected_certificat_RGE?.date_attribution
                              )
                            }}
                          </b>
                          valable jusqu'au
                          <b>{{
                            formatDate(
                              group.selected_certificat_RGE?.date_expiration
                            )
                          }}</b
                          >, Assurance
                        </div>
                        <div class="">
                          civile
                          <b>
                            N°
                            {{
                              devisObject.data?.devis?.entreprise?.num_assurance
                            }}</b
                          >
                        </div>
                      </div>
                    </div>
                    <div class="mx-4">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                 
                   
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-EN-102'">
                    <div>
                      <div class="">
                        <div class="piece"> Isolation des murs</div>
                        <div class="mx-4 mt-2">
                          Mise en place d’un procédé d’isolation (complexe ou
                          sur ossature) sur mur(s) en façade ou en pignon. Un
                          procédé d'isolation est constitué de l'association
                          d'un matériau isolant et de dispositifs de fixation et
                          de protection (tels que des revêtements, parements,
                          membranes continues si nécessaire) contre des
                          dégradations liées à son exposition aux environnements
                          extérieurs et intérieurs (telles que le rayonnement
                          solaire, le vent, la pluie, la neige, les chocs,
                          l'humidité, le feu).

                          <div>Caractéristiques de l'isolant posé:</div>

                          <div>
                            Surface d’isolant posé:
                            <b
                              >{{
                                devisObject.data.devis?.isolation_murs
                                  ?.Surface_isolant
                              }}
                              m²</b
                            >
                          </div>
                          <div>
                            Résistance thermique:
                            <b
                              >{{
                                devisObject.data.devis?.isolation_murs
                                  ?.resistance_thermique
                              }}
                              m².K/W</b
                            >
                          </div>
                          <div>
                            Épaisseur:
                            <b
                              >{{
                                devisObject.data.devis?.isolation_murs
                                  ?.epaisseur
                              }}
                              mm</b
                            >
                          </div>
                          <div>
                            <div>
                              Type d’isolant :

                              <b>{{
                                formatTypeIsolant(
                                  devisObject.data.devis?.isolation_murs
                                    ?.type_isolant
                                )
                              }}</b>
                            </div>
                            <div>
                              La résistance thermique est évaluée selon la norme
                              <b>{{
                                devisObject.data?.devis?.isolation_murs?.norme
                              }}</b><template v-if="devisObject.data?.devis?.isolation_murs?.norme2"> et <b>{{
                                devisObject.data?.devis?.isolation_murs?.norme2
                              }}</b></template>
                            </div>
                          </div>
                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  
                
                  </div>

                  <div class="" v-if="group.type_group === 'BAR-TH-143'">
                    <div>
                      <div class="">
                        <div class="piece">
                           Système solaire combiné
                        </div>
                        <div class="mx-4 mt-2">
                          Mise en place d’un système solaire combiné (SSC)
                          destiné au chauffage et à la production d’eau chaude
                          sanitaire.

                          <div>Caractéristiques :</div>
                          <div
                            v-if="
                              devisObject.data.devis?.systeme_solaire
                                ?.have_certification
                            "
                          >
                            Les capteurs solaire ont une certification
                            <b>{{
                              devisObject.data.devis?.systeme_solaire
                                ?.certification
                            }}</b>
                            reposant sur la norme
                            <b>{{
                              devisObject.data.devis?.systeme_solaire?.norme
                            }}</b
                            >.
                          </div>
                          <div
                            v-if="
                              !devisObject.data.devis?.systeme_solaire
                                ?.have_certification
                            "
                          >
                            Les capteurs possèdent des caractéristiques de
                            performances et de qualité équivalentes, certifiées
                            par un organisme accrédité dans l'Espace Économique
                            Européen, reposant sur la norme
                            <b>{{
                              devisObject.data.devis?.systeme_solaire?.norme
                            }}</b
                            >.
                          </div>
                          <div>
                            Nature du fluide capteurs :
                            <b>{{
                              devisObject.data.devis?.systeme_solaire
                                ?.nature_fluide
                            }}</b>
                          </div>
                          <div>
                            La surface chauffée :
                            <b
                              >{{
                                devisObject.data.devis?.systeme_solaire
                                  ?.surface_chaufe
                              }}
                              m²</b
                            >
                          </div>

                          <div>
                            La surface hors tout de capteurs installés:<b
                              >{{
                                devisObject.data.devis?.systeme_solaire
                                  ?.surface_hors_tout
                              }}
                              m²</b
                            >
                          </div>
                          <div>
                            Capacité de stockage :
                            <b
                              >{{
                                devisObject.data.devis?.systeme_solaire
                                  ?.capacite_stockage
                              }}
                            </b>
                          </div>
                          <div>
                            Efficacité énergétique de classe
                            <b>{{
                              devisObject.data.devis?.systeme_solaire
                                ?.classe_efficacite_energetique
                            }}</b>
                            déterminée conformément au règlement (UE) no
                            812/2013 de la Commission du 18 février 2013
                          </div>
                          <div>
                            La productivité des capteurs, calculée avec un
                            rayonnement de 1000W/m² :
                            <b
                              >{{
                                devisObject.data.devis?.systeme_solaire
                                  ?.productivite
                              }}
                              W/m²</b
                            >
                          </div>

                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="mx-4" v-if='group?.cumac'>
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
             
                   
                  </div>
              <div class="" v-if="group.type_group === 'BAR-EN-101'">
                    <div class="">
                      <div class="piece">
                         Isolation de combles ou de toiture
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’un procédé d’isolation thermique en
                        comble perdu ou en rampant de toiture. Un procédé
                        d'isolation est constitué de l'association d'un matériau
                        isolant et de dispositifs de fixation et de protection
                        (tels que des revêtements, parements, membranes
                        continues si nécessaire) contre des dégradations liées à
                        son exposition aux environnements extérieurs et
                        intérieurs (telles que le rayonnement solaire, le vent,
                        la pluie, la neige, les chocs, l'humidité, le feu).
                        <div>
                          Type de pose :
                          <b>
                            {{
                              devisObject.data.devis?.isolation_combles_toiture
                                ?.type_pose
                            }}</b
                          >
                        </div>
                        <div>
                          Caractéristiques de l'isolant posé:
                          <div>
                            <div>
                              Type d’isolant :

                              <b>{{
                                formatTypeIsolant(
                                  devisObject.data.devis
                                    ?.isolation_combles_toiture?.type_isolant
                                )
                              }}</b>
                            </div>
                            <div>
                              La résistance thermique est évaluée selon la norme
                              <b>{{
                                devisObject.data?.devis
                                  ?.isolation_combles_toiture?.norme
                              }}</b><template v-if="devisObject.data?.devis?.isolation_combles_toiture?.norme2"> et <b>{{
                                devisObject.data?.devis?.isolation_combles_toiture?.norme2
                              }}</b></template>
                            </div>
                          </div>
                        </div>

                        <div>
                          Surface d’isolant posé:
                          <b
                            >{{
                              devisObject.data.devis?.isolation_combles_toiture
                                ?.surface_isolant
                            }}
                            m²</b
                          >
                        </div>
                        <div>
                          Résistance thermique:
                          <b
                            >{{
                              devisObject.data.devis?.isolation_combles_toiture
                                ?.resistance_thermique
                            }}
                            m².K/W</b
                          >
                        </div>
                        <div>
                          Épaisseur:
                          <b
                            >{{
                              devisObject.data.devis?.isolation_combles_toiture
                                ?.epaisseur
                            }}
                            mm</b
                          >
                        </div>
                        <div>
                          <div>
                            Type d’isolant :

                              <b>{{
                                formatTypeIsolant(
                                  devisObject.data.devis?.isolation_combles_toiture
                                    ?.type_isolant
                                )
                              }}</b>
                          </div>
                          <div>
                            La résistance thermique est évaluée selon la norme
                            <b>{{
                              devisObject.data?.devis?.isolation_combles_toiture
                                ?.norme
                            }}</b><template v-if="devisObject.data?.devis?.isolation_combles_toiture?.norme2"> et <b>{{
                              devisObject.data?.devis?.isolation_combles_toiture?.norme2
                            }}</b></template>
                          </div>
                        </div>
                        <div
                          v-if="
                            devisObject.data?.devis?.isolation_combles_toiture
                              ?.necessite_pare_vapeur === 1
                          "
                        >
                          L’isolation thermique réalisée a nécessité la mise en
                          place d’un pare-vapeur ou tout autre dispositif
                          permettant d'atteindre un résultat équivalen
                        </div>
                        <div
                          v-for="(chantierItem, index) in group.products"
                          :key="index"
                        >
                          <div>
                            <div v-if="chantierItem.type_ligne === 'Product'">
                              <div>
                                Marque :
                                {{ chantierItem.fabricant }}
                              </div>
                              <div>
                                Réf :
                                {{ chantierItem.ref }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                 
                  </div>

                  <div class="" v-if="group.type_group === 'BAR-TH-127'">
                    <div class="">
                      <div class="piece">
                         Ventilation mécanique simple flux
                        hygroréglable (France métropolitaine)
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’un système de ventilation mécanique
                        contrôlée (VMC) simple flux hygroréglable ou d’un
                        système de ventilation mécanique basse pression (VMBP)
                        collectif simple flux hygroréglable. Ces systèmes de
                        ventilation peuvent être de type A ou B.
                        <div>
                          <div>
                            Type d’installation :
                            <b>{{
                              devisObject.data.devis
                                ?.systeme_ventilation_mecanique_controlee
                                ?.type_installation
                            }}</b>
                          </div>
                          <div>
                            Type de ventilation mécanique contrôlée :
                            <b>{{
                              devisObject.data.devis
                                ?.systeme_ventilation_mecanique_controlee
                                ?.type_ventilation
                            }}</b>
                          </div>
                          <div>
                            Type de système de ventilation :
                            <b>{{
                              devisObject.data.devis
                                ?.systeme_ventilation_mecanique_controlee?.type
                            }}</b>
                          </div>
                          <div>
                            <div
                              v-if="
                                devisObject.data.devis
                                  ?.systeme_ventilation_mecanique_controlee
                                  ?.type_installation ===
                                'Installation collective'
                              "
                            >
                              Nombre de logements desservis :
                              <b>
                                {{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.nombre_logements
                                }}</b
                              >. Puissance
                              <b>
                                {{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.puissance_electrique
                                }}</b
                              >
                            </div>
                            <div
                              v-if="
                                devisObject.data.devis
                                  ?.systeme_ventilation_mecanique_controlee
                                  ?.type_installation ===
                                'Installation individuelle'
                              "
                            >
                              <div>
                                Surface habitable (m²) :
                                <b>{{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.surface_habitable
                                }}</b>
                              </div>
                              <div>
                                Classe énergétique du système de ventilation
                                selon le règlement européen (UE) n° 1254/2014 :
                                <b>{{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.classe_energetique
                                }}</b>
                              </div>
                            </div>
                          </div>

                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                 
                  </div>
                  <div class="" v-if="group.type_group === 'BAT-TH-142'">
                    <div class="">
                      <div class="piece">
                        BAT-TH-142: Système de déstratification d’air

                      </div>
                      <div class="mx-4 mt-2">
                       Mise en place d’un système de déstratification d’air pour l’homogénéisation de la température de l’air d’un local de
grande hauteur chauffé par un système convectif et/ou radiatif.
Un système de déstratification d’air est un système permettant d’homogénéiser la température d’un local en
redistribuant la chaleur située à proximité du plafond vers le sol, sans apport de chaleur propre au système de
déstratification. Il est indépendant du système de chauffage.
La présente fiche s’applique aux opérations engagées jusqu’au 30 juin 2028.
                      <div
                        v-if="devisObject.data?.devis?.systeme_destratification_air"
                        class="mt-2"
                      >
                        <div>
                          Type de local :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.local_type || "-" }}</b>
                        </div>
                        <div>
                          Hauteur sous plafond (m) :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.hauteur_sous_plafond || "-" }}</b>
                        </div>
                        <div>
                          Écoulement :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.ecoulement || "-" }}</b>
                        </div>
                        <div>
                          Vitesse conforme :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.vitesse === 1 ||
                              devisObject.data.devis.systeme_destratification_air.vitesse === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div>
                          Type de chauffage :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.chauffage || "-" }}</b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.ecoulement === 'vertical'">
                          Aspiration verticale :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.vertical_aspiration === 1 ||
                              devisObject.data.devis.systeme_destratification_air.vertical_aspiration === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.ecoulement === 'horizontal'">
                          Aspiration horizontale haut :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.horizontal_aspiration_haut === 1 ||
                              devisObject.data.devis.systeme_destratification_air.horizontal_aspiration_haut === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.ecoulement === 'horizontal'">
                          Aspiration horizontale bas :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.horizontal_aspiration_bas === 1 ||
                              devisObject.data.devis.systeme_destratification_air.horizontal_aspiration_bas === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div>
                          Mesure de température :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.mesure_temperature === 1 ||
                              devisObject.data.devis.systeme_destratification_air.mesure_temperature === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div>
                          Niveau de bruit &lt; 45 dB :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.niveau_bruit === 1 ||
                              devisObject.data.devis.systeme_destratification_air.niveau_bruit === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div>
                          Ne permet pas de chauffer :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.pas_de_chauffage === 1 ||
                              devisObject.data.devis.systeme_destratification_air.pas_de_chauffage === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.chauffage === 'convectif' || devisObject.data.devis.systeme_destratification_air.chauffage === 'both'">
                          Puissance convectif (kW) :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.puissance_convectif || "-" }}</b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.chauffage === 'radiatif' || devisObject.data.devis.systeme_destratification_air.chauffage === 'both'">
                          Puissance radiatif (kW) :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.puissance_radiatif || "-" }}</b>
                        </div>
                        <div>
                          Nombre de déstratificateurs :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.nombre_destratificateurs || "-" }}</b>
                        </div>
                      </div>
                      <div v-else class="mt-2">
                        {{ $t("NO_DATA_FOUND") }}
                      </div>
<!-- 
                        <div>
                          <div>
                            <div
                              v-if="
                                devisObject.data?.devis?.logement?.type ===
                                'Maison individuelle'
                              "
                            >
                              Surface habitable :
                              <b>{{
                                devisObject.data.devis
                                  ?.raccordement_batiment_residentiel_reseau_chaleur
                                  ?.surface_habitable
                              }}</b>
                              m².
                            </div>
                            <div v-else>
                              Nombre des appartements
                              <b>{{
                                devisObject.data.devis
                                  ?.raccordement_batiment_residentiel_reseau_chaleur
                                  ?.nbr_appartements
                              }}</b>
                              m².
                            </div>
                            <div
                              v-if="
                                devisObject.data.devis
                                  ?.raccordement_batiment_residentiel_reseau_chaleur
                                  ?.deja_raccorder
                              "
                            >
                              Le bâtiment a été raccordé précédemment, le ou les
                              raccordements précédents ont fait l'objet d'une
                              demande de

                              <div
                                v-if="
                                  devisObject.data.devis
                                    ?.raccordement_batiment_residentiel_reseau_chaleur
                                    .existe_cetificat_economie
                                "
                              >
                                Certificats d’économies d’énergie
                              </div>
                              <div
                                v-if="
                                  !devisObject.data.devis
                                    ?.raccordement_batiment_residentiel_reseau_chaleur
                                    .existe_cetificat_economie
                                "
                              >
                                certificats d’économies d’énergie
                              </div>
                            </div>
                            <div
                              v-if="
                                !devisObject.data.devis
                                  ?.raccordement_batiment_residentiel_reseau_chaleur
                                  ?.deja_raccorder
                              "
                            >
                              Le bâtiment n’a jamais été raccordé à un réseau de
                              chaleur dans le délai de cinq ans précédant la
                              date de l'engagement de l'opération
                            </div>
                            Nom du réseau
                            <b>{{
                              devisObject.data.devis
                                ?.raccordement_batiment_residentiel_reseau_chaleur
                                ?.nom_reseau
                            }}</b>
                          </div>
                          <div>
                            <div
                              v-if="
                                devisObject.data.devis
                                  ?.systeme_ventilation_mecanique_controlee
                                  ?.type_installation ===
                                'Installation collective'
                              "
                            >
                              Nombre de logements desservis :
                              <b>
                                {{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.nombre_logements
                                }}</b
                              >. Puissance
                              <b>
                                {{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.puissance_electrique
                                }}</b
                              >
                            </div>
                            <div
                              v-if="
                                devisObject.data.devis
                                  ?.systeme_ventilation_mecanique_controlee
                                  ?.type_installation ===
                                'Installation individuelle'
                              "
                            >
                              <div>
                                Surface habitable (m²) :
                                <b>{{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.surface_habitable
                                }}</b>
                              </div>
                              <div>
                                Classe énergétique du système de ventilation
                                selon le règlement européen (UE) n° 1254/2014 :
                                <b>{{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.classe_energetique
                                }}</b>
                              </div>
                            </div>
                          </div>

                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  
                 
                  </div>
                    <div class="" v-if="group.type_group === 'BAR-TH-137'">
                    <div class="">
                      <div class="piece">
                        Raccordement d’un bâtiment résidentiel à un
                        réseau de chaleur
                      </div>
                      <div class="mx-4 mt-2">
                        Raccordement d’un bâtiment résidentiel existant à un
                        réseau de chaleur.
                        <div>
                          <div>
                            <div
                              v-if="
                                devisObject.data?.devis?.logement?.type ===
                                'Maison individuelle'
                              "
                            >
                              Surface habitable :
                              <b>{{
                                devisObject.data.devis
                                  ?.raccordement_batiment_residentiel_reseau_chaleur
                                  ?.surface_habitable
                              }}</b>
                              m².
                            </div>
                            <div v-else>
                              Nombre des appartements
                              <b>{{
                                devisObject.data.devis
                                  ?.raccordement_batiment_residentiel_reseau_chaleur
                                  ?.nbr_appartements
                              }}</b>
                              m².
                            </div>
                            <div
                              v-if="
                                devisObject.data.devis
                                  ?.raccordement_batiment_residentiel_reseau_chaleur
                                  ?.deja_raccorder
                              "
                            >
                              Le bâtiment a été raccordé précédemment, le ou les
                              raccordements précédents ont fait l'objet d'une
                              demande de

                              <div
                                v-if="
                                  devisObject.data.devis
                                    ?.raccordement_batiment_residentiel_reseau_chaleur
                                    .existe_cetificat_economie
                                "
                              >
                                Certificats d’économies d’énergie
                              </div>
                              <div
                                v-if="
                                  !devisObject.data.devis
                                    ?.raccordement_batiment_residentiel_reseau_chaleur
                                    .existe_cetificat_economie
                                "
                              >
                                certificats d’économies d’énergie
                              </div>
                            </div>
                            <div
                              v-if="
                                !devisObject.data.devis
                                  ?.raccordement_batiment_residentiel_reseau_chaleur
                                  ?.deja_raccorder
                              "
                            >
                              Le bâtiment n’a jamais été raccordé à un réseau de
                              chaleur dans le délai de cinq ans précédant la
                              date de l'engagement de l'opération
                            </div>
                            Nom du réseau
                            <b>{{
                              devisObject.data.devis
                                ?.raccordement_batiment_residentiel_reseau_chaleur
                                ?.nom_reseau
                            }}</b>
                          </div>
                          <div>
                            <div
                              v-if="
                                devisObject.data.devis
                                  ?.systeme_ventilation_mecanique_controlee
                                  ?.type_installation ===
                                'Installation collective'
                              "
                            >
                              Nombre de logements desservis :
                              <b>
                                {{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.nombre_logements
                                }}</b
                              >. Puissance
                              <b>
                                {{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.puissance_electrique
                                }}</b
                              >
                            </div>
                            <div
                              v-if="
                                devisObject.data.devis
                                  ?.systeme_ventilation_mecanique_controlee
                                  ?.type_installation ===
                                'Installation individuelle'
                              "
                            >
                              <div>
                                Surface habitable (m²) :
                                <b>{{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.surface_habitable
                                }}</b>
                              </div>
                              <div>
                                Classe énergétique du système de ventilation
                                selon le règlement européen (UE) n° 1254/2014 :
                                <b>{{
                                  devisObject.data.devis
                                    ?.systeme_ventilation_mecanique_controlee
                                    ?.classe_energetique
                                }}</b>
                              </div>
                            </div>
                          </div>

                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  
                 
                  </div>
                    <div class="" v-if="group.type_group === 'BAT-TH-142'">
                    <div class="">
                      <div class="piece">
                        BAT-TH-142: Système de déstratification d’air

                      </div>
                      <div
                        v-if="devisObject.data?.devis?.systeme_destratification_air"
                        class="mx-4 mt-2"
                      >
                        <div>
                          Type de local :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.local_type || "-" }}</b>
                        </div>
                        <div>
                          Hauteur sous plafond (m) :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.hauteur_sous_plafond || "-" }}</b>
                        </div>
                        <div>
                          Écoulement :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.ecoulement || "-" }}</b>
                        </div>
                        <div>
                          Vitesse conforme :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.vitesse === 1 ||
                              devisObject.data.devis.systeme_destratification_air.vitesse === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div>
                          Type de chauffage :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.chauffage || "-" }}</b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.ecoulement === 'vertical'">
                          Aspiration verticale :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.vertical_aspiration === 1 ||
                              devisObject.data.devis.systeme_destratification_air.vertical_aspiration === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.ecoulement === 'horizontal'">
                          Aspiration horizontale haut :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.horizontal_aspiration_haut === 1 ||
                              devisObject.data.devis.systeme_destratification_air.horizontal_aspiration_haut === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.ecoulement === 'horizontal'">
                          Aspiration horizontale bas :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.horizontal_aspiration_bas === 1 ||
                              devisObject.data.devis.systeme_destratification_air.horizontal_aspiration_bas === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div>
                          Mesure de température :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.mesure_temperature === 1 ||
                              devisObject.data.devis.systeme_destratification_air.mesure_temperature === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div>
                          Niveau de bruit &lt; 45 dB :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.niveau_bruit === 1 ||
                              devisObject.data.devis.systeme_destratification_air.niveau_bruit === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div>
                          Ne permet pas de chauffer :
                          <b>
                            {{
                              devisObject.data.devis.systeme_destratification_air.pas_de_chauffage === 1 ||
                              devisObject.data.devis.systeme_destratification_air.pas_de_chauffage === true
                                ? "Oui"
                                : "Non"
                            }}
                          </b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.chauffage === 'convectif' || devisObject.data.devis.systeme_destratification_air.chauffage === 'both'">
                          Puissance convectif (kW) :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.puissance_convectif || "-" }}</b>
                        </div>
                        <div v-if="devisObject.data.devis.systeme_destratification_air.chauffage === 'radiatif' || devisObject.data.devis.systeme_destratification_air.chauffage === 'both'">
                          Puissance radiatif (kW) :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.puissance_radiatif || "-" }}</b>
                        </div>
                        <div>
                          Nombre de déstratificateurs :
                          <b>{{ devisObject.data.devis.systeme_destratification_air.nombre_destratificateurs || "-" }}</b>
                        </div>
                      </div>
                      <div v-else class="mx-4 mt-2">
                        {{ $t("NO_DATA_FOUND") }}
                      </div>
                 
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                   
                  
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-TH-129'">
                    <div class="">
                      <div class="piece">
                      Pompe à chaleur de type air/air
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’une pompe à chaleur (PAC) de type
                        air/air.
                        <div>
                          <div>
                            Surface chauffée :
                            <b>{{
                              devisObject.data.devis?.pompe_chaleur_air_air
                                ?.surface_chauffee
                            }}</b>
                            m²
                          </div>
                          <div>
                            Coefficient de performance saisonnier (SCOP)
                            <b>{{
                              devisObject.data.devis?.pompe_chaleur_air_air
                                ?.coefficient_performance_saisonnier
                            }}</b>
                          </div>
                          <div>
                            Puissance nominale de la PAC
                            <b>{{
                              devisObject.data.devis?.pompe_chaleur_air_air
                                ?.puissance_nominale
                            }}</b>
                            en kW
                          </div>

                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                 
                  
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-TH-148'">
                    <div class="">
                      <div class="piece">
                   Chauffe-eau thermodynamique à accumulation
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’un chauffe-eau thermodynamique
                        individuel à accumulation.

                        <div>
                          Caractéristiques du chauffe-eau thermodynamique :

                          <div>
                            Type d’installation :
                            <b>{{
                              devisObject.data.devis
                                ?.chauffe_eau_thermodynamiques
                                ?.type_installation
                            }}</b>
                          </div>
                          <div>
                            COP :
                            <b>{{
                              devisObject.data.devis
                                ?.chauffe_eau_thermodynamiques?.cop
                            }}</b>
                          </div>
                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                      
                      
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-SE-108'">
                    <div class="">
                      <div class="piece">Désembouage d’un réseau hydraulique individuel de chauffage
                       en France métropolitaine</div>
                      <div class="mx-4 mt-2">
                      <div>Désembouage de l’ensemble du système de distribution par boucle d'eau d’une installation individuelle de chauffage
                         dont la puissance thermique nominale est inférieure ou égale à 70 kW.
                          </div>
                        <div v-if="devisObject.data?.devis?.desembouage_reseau_hydraulique_individuel_chauffage" class="mt-2">
                          <div>Installation individuelle de chauffage : <b>{{ (devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.installation_individuelle === 1 || devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.installation_individuelle === true) ? "Oui" : "Non" }}</b></div>
                          <div>La ou les boucles d’eau chauffées, en tout ou partie, par une pompe à chaleur de type air/eau, eau/eau ou sol/eau ou par une pompe à chaleur hybride sont exclues : <b>{{ (devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.boucles_pac_exclues === 1 || devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.boucles_pac_exclues === true) ? "Oui" : "Non" }}</b></div>
                          <div>Puissance thermique nominale (kW) : <b>{{ devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.puissance_thermique_kw ?? "-" }}</b></div>
                         <div>Les étapes suivantes ont été réalisées </div>
                          <div v-if="devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.etape_rinçage_eau === 1 || devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.etape_rinçage_eau === true">
                            - Rinçage à l'eau du système de distribution par boucle d'eau (général puis réseau par réseau)
                          </div>
                          <div v-if="devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.etape_injection_desembouant === 1 || devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.etape_injection_desembouant === true">
                            - Injection d'un réactif désembouant et circulation selon le dosage et le temps de contact préconisés, avec l'utilisation d'une pompe de désembouage (général puis réseau par réseau ; dans les deux sens de circulation)
                          </div>
                          <div v-if="devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.etape_rinçage_eau_claire === 1 || devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.etape_rinçage_eau_claire === true">
                             - Rinçage des circuits à l'eau claire (général puis réseau par réseau)
                          </div>
                          <div v-if="devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.etape_verification_filtre === 1 || devisObject.data.devis.desembouage_reseau_hydraulique_individuel_chauffage.etape_verification_filtre === true">
                             - Vérification du filtre (ou pot à boues) existant et/ou installation d'un filtre sur le ou les circuits de retour au générateur, ainsi que l'injection d'un réactif inhibiteur au dosage préconisé
                          </div>
                              <div class="">
                  Cumac : <b>{{ group?.cumac }} kWh</b>
                </div>
                        </div>
                    
                        <div v-else class="mt-2">{{ $t("NO_DATA_FOUND") }}</div>
                        <div v-for="(chantierItem, index) in group.products" :key="index">
                          <div v-if="chantierItem.type_ligne === 'Product'">
                            <div>Marque : {{ chantierItem.fabricant }}</div>
                            <div>Réf : {{ chantierItem.ref }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-TH-161'">
                    <div class="">
                      <div class="piece">
Isolation de points singuliers d’un réseau
                      </div>
                      <div class="mx-4 mt-2">
                        <p>Mise en place de housses pour l'isolation de points singuliers sur un réseau hydraulique isolé de chauffage et/ou d'eau chaude sanitaire, situé dans une sous-station ou dans une chaufferie pour un système collectif.</p>
                        <div v-if="devisObject.data?.devis?.isolation_points_singuliers_reseau" class="mt-2">
                          <div>Nombre de housses isolantes mises en place : <b>{{ devisObject.data.devis.isolation_points_singuliers_reseau.nombre_housses ?? "-" }}</b></div>
                          <div>Diamètre nominal (DN) de la canalisation (mm) : <b>{{ devisObject.data.devis.isolation_points_singuliers_reseau.diametre_nominal_dn ?? "-" }}</b></div>
                          <div v-if="devisEnIpsrFluideNum !== null">Température du fluide caloporteur Tfluide : <b>{{ devisEnIpsrFluideNum }} °C</b></div>
                          <div>Housse souple, démontable, système de fermeture : <b>{{ (devisObject.data.devis.isolation_points_singuliers_reseau.housse_souple_demontable === 1 || devisObject.data.devis.isolation_points_singuliers_reseau.housse_souple_demontable === true) ? "Oui" : "Non" }}</b></div>
                          <div>Laine minérale : <b>{{ (devisObject.data.devis.isolation_points_singuliers_reseau.laine_minerale === 1 || devisObject.data.devis.isolation_points_singuliers_reseau.laine_minerale === true) ? "Oui" : "Non" }}</b></div>
                          <div>Température max. service : <b>{{ devisObject.data.devis.isolation_points_singuliers_reseau.temperature_max_service || "-" }} °C</b></div>
                          <div>R (m².K/W) à 50°C : <b>{{ devisObject.data.devis.isolation_points_singuliers_reseau.resistance_thermique_50 || "-" }}</b></div>
                          <div>R (m².K/W) à 100°C : <b>{{ devisObject.data.devis.isolation_points_singuliers_reseau.resistance_thermique_100 || "-" }}</b></div>
                          <div>Date état récapitulatif : <b>{{ devisObject.data.devis.isolation_points_singuliers_reseau.date_etat_recapitulatif ? formatDate(devisObject.data.devis.isolation_points_singuliers_reseau.date_etat_recapitulatif) : "-" }}</b></div>
                        </div>
                        <div v-else class="mt-2">{{ $t("NO_DATA_FOUND") }}</div>
                        <div v-for="(chantierItem, index) in group.products" :key="index">
                          <div v-if="chantierItem.type_ligne === 'Product'">
                            <div>Marque : {{ chantierItem.fabricant }}</div>
                            <div>Réf : {{ chantierItem.ref }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-TH-173'">
                    <div class="">
                      <div class="piece">
                         Système de régulation par programmation
                        horaire pièce par pièce
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place, sur une installation de chauffage neuve
                        ou existante, d’un dispositif centralisé assurant une
                        fonction de programmation et régulation différenciée de
                        la température intérieure (quatre allures au moins selon
                        les besoins : confort, économie, hors-gel et arrêt)
                        selon les normes EN 12098-1 et EN 12098-3 dans toutes
                        les pièces équipées d’un émetteur de chaleur sans
                        exception du logement, selon des plages horaires.

                        <div>
                          Caractéristiques :

                          <div>
                            L’opération concerne :
                            <b>{{
                              devisObject.data.devis?.systeme_regulation_horaire
                                ?.concerne
                            }}</b>
                          </div>
                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire?.remlpacement
                            "
                            >Le système existant est remplacé</b
                          >
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire?.remlpacement
                            "
                            >Le système existant n'est pas remplacé</b
                          >. Le dispositif installé
                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.comporte_appareil_central
                            "
                            >est centralisé
                          </b>
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.comporte_appareil_central
                            "
                            >n'est pas centralisé</b
                          >

                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.dispose_sonde_mesure
                            "
                          >
                            d'une sonde de mesure</b
                          >
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.dispose_sonde_mesure
                            "
                            >n'y a pas de sonde de mesure</b
                          >
                          possède les fonctions de régulation de la classe
                          <b>{{
                            devisObject.data.devis?.systeme_regulation_horaire
                              ?.class
                          }}</b>
                          selon la norme NF EN ISO 52120-1,
                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.ancient_system_class_c
                            "
                            >L'ancien dispositif installé est de classe C selon
                            la norme NF EN ISO 52120-1 pour les bâtiments
                            résidentiels.
                          </b>
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.ancient_system_class_c
                            "
                            >L'ancien dispositif installé n'est pas de classe C
                          </b>

                          <div>
                            L’équipement de régulation est installé sur un
                            système de chauffage
                            <b
                              v-if="
                                devisObject.data.devis?.type_devis
                                  .systeme_regulation_horaire
                                  ?.planchers_plafonds_chauffants
                              "
                            >
                              est d'une planchers chauffants ou bien d'une
                              plafonds chauffants</b
                            >
                            <b
                              v-if="
                                !devisObject.data.devis?.type_devis
                                  .systeme_regulation_horaire
                                  ?.planchers_plafonds_chauffants
                              "
                            >
                              n'est pas d'une planchers chauffants ni d'une
                              plafonds chauffants</b
                            >
                            selon les normes EN 12098-1 et EN 12098-3.
                          </div>

                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.pieces_equipees_emetteur
                            "
                            >Les pièces sont équipées d'émetteurs
                          </b>
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.pieces_equipees_emetteur
                            "
                            >Les pièces n'sont pas équipées d'émetteurs </b
                          >,
                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.logement_equipees_emetteur
                            "
                            >le boîtier est équipé d'émetteurs</b
                          >
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.logement_equipees_emetteur
                            "
                            >le boîtier n'est pas équipé d'émetteurs</b
                          >.
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.fonctionner_perte_connexion
                            "
                            >Le système ne fonctionne pas en cas de perte de
                            connexion</b
                          >.
                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.fonctionner_perte_connexion
                            "
                            >Le système fonctionne en cas de perte de
                            connexion</b
                          >.
                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.effectuer_local_minima
                            "
                            >et fonctionne localement</b
                          >
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.effectuer_local_minima
                            "
                            >et ne fonctionne pas localement
                          </b>

                          <b
                            v-if="
                              devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.deroger_localement_consignes
                            "
                          >
                            La dérogation locale est possible</b
                          >
                          <b
                            v-if="
                              !devisObject.data.devis?.type_devis
                                .systeme_regulation_horaire
                                ?.deroger_localement_consignes
                            "
                            >La dérogation locale n'est pas possible</b
                          >

                          Surface habitable<b>
                            {{
                              devisObject.data.devis?.systeme_regulation_horaire
                                ?.surface_chauffe
                            }}
                            m²</b
                          >
                          Nombre total d’émetteurs de chaleur du logement :
                          <b>
                            {{
                              devisObject.data.devis?.systeme_regulation_horaire
                                ?.nbr_logement
                            }}
                          </b>
                          <div>
                            COP :
                            <b>{{
                              devisObject.data.devis
                                ?.chauffe_eau_thermodynamiques?.cop
                            }}</b>
                          </div>
                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                      <div class="mx-4" v-if="group?.cumac">
                        Cumac : <b>{{ group?.cumac }} kWh</b>
                      </div>
                   
                  
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  
                    
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-TH-171'">
                    <div class="">
                      <div class="piece">
                       Pompe à chaleur de type air/eau
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’une pompe à chaleur (PAC) de type
                        air/eau.

                        <div>
                          Caractéristiques d'une pompe à chaleur de type air/eau
                          :
                          <div>
                            <div>
                              La pompe à chaleur est de type air/eau et est
                              installée pour une application de température :
                              <b
                                >{{
                                  devisObject.data.devis?.systeme_chauffage
                                    ?.denomination_temperature
                                }}
                              </b>
                            </div>
                            <div>
                              Le coefficient de performance (COP) est de :
                              <b>{{
                                devisObject.data.devis?.systeme_chauffage
                                  ?.coefficient_performance
                              }}</b>
                            </div>
                            <div>
                              Classe du régulateur :
                              <b>{{
                                devisObject.data.devis?.systeme_chauffage
                                  ?.regulateur_classer
                              }}</b>
                            </div>
                            <div>
                              L'efficacité énergitique saisonnière est de :
                              <b
                                >{{
                                  devisObject.data.devis?.systeme_chauffage
                                    ?.efficacite
                                }}
                                %</b
                              >
                              calculée selon le règlement (EU)
                            </div>
                            <div>
                              n°813/2013 de la commission du 2 aout 2013
                            </div>
                            <div>
                              La surface chauffée par la PAC est de
                              <b>{{
                                devisObject.data.devis?.systeme_chauffage
                                  ?.surface_chauffee
                              }}</b>
                            </div>
                            <div
                              v-for="(chantierItem, index) in group.products"
                              :key="index"
                            >
                              <div>
                                <div
                                  v-if="chantierItem.type_ligne === 'Product'"
                                >
                                  <div>
                                    Marque :
                                    {{ chantierItem.fabricant }}
                                  </div>
                                  <div>
                                    Réf :
                                    {{ chantierItem.ref }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div>
                              Mise en place d'un régulateur de classe :
                              <b>{{
                                devisObject.data.devis?.systeme_chauffage
                                  ?.regulateur_classe
                              }}</b>
                            </div>
                            <div></div>
                            <ul>
                              <li>
                                Dépose et remplacement d'une chaudière
                                <b>{{
                                  devisObject?.data?.devis?.systeme_chauffage
                                    ?.equipement_deposee
                                }}</b>
                              </li>
                            </ul>
                          </div>

                          <div
                            v-for="(chantierItem, index) in group.products"
                            :key="index"
                          >
                            <div>
                              <div v-if="chantierItem.type_ligne === 'Product'">
                                <div>
                                  Marque :
                                  {{ chantierItem.fabricant }}
                                </div>
                                <div>
                                  Réf :
                                  {{ chantierItem.ref }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                     
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                
                  
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-EN-104'">
                    <div class="mt-3">
                      <div class="piece">
                        Fenêtre ou porte-fenêtre complète avec
                        vitrage isolant
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’une fenêtre, fenêtre de toiture ou
                        porte-fenêtre complète avec vitrage isolant, les baies
                        fixes étant permises, pour le remplacement d’une
                        fenêtre, fenêtre de toiture ou porte-fenêtre équipée de
                        simple vitrage avant travaux ou mise en place d’une
                        double fenêtre sur une fenêtre équipée de simple vitrage
                        avant travaux. L’opération inclut le remplacement du
                        dormant existant, sauf dans le cas de l’installation
                        d’une double fenêtre.

                        <div>Caractéristiques :</div>
                        <div>
                          Type de fenêtre:<b
                            >{{
                              devisObject.data.devis?.fenetre_vitrage_complet
                                ?.type_fenetre
                            }}
                          </b>
                        </div>
                        <div>
                          Nombre de
                          {{
                            devisObject.data.devis?.fenetre_vitrage_complet
                              ?.type_fenetre
                          }}:
                          <b
                            >{{
                              devisObject.data.devis?.fenetre_vitrage_complet
                                ?.nombre_fenetres
                            }}
                          </b>
                        </div>
                        <div>
                          Surface totale de
                          {{
                            devisObject.data.devis?.fenetre_vitrage_complet
                              ?.type_fenetre
                          }}:
                          <b
                            >{{
                              devisObject.data.devis?.fenetre_vitrage_complet
                                ?.surface_totale
                            }}
                            m²
                          </b>
                        </div>
                        <div>
                          <div>
                            Coefficient de transmission surfacique Uw:

                            <b
                              >{{
                                devisObject.data.devis?.fenetre_vitrage_complet
                                  ?.coefficient_transmission
                              }}
                              W/m².K</b
                            >
                          </div>
                          <div>
                            Facteur solaire Sw :
                            <b>{{
                              devisObject.data?.devis?.fenetre_vitrage_complet
                                ?.facteur_solaire
                            }}</b>
                          </div>
                        </div>
                        <div
                          v-for="(chantierItem, index) in group.products"
                          :key="index"
                        >
                          <div>
                            <div v-if="chantierItem.type_ligne === 'Product'">
                              <div>
                                Marque :
                                {{ chantierItem.fabricant }}
                              </div>
                              <div>
                                Réf :
                                {{ chantierItem.ref }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                
                  
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-TH-101'">
                    <div class="mt-3">
                      <div class="piece">
                         Chauffe-eau solaire individuel
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’un chauffe-eau solaire individuel
                        (CESI).

                        <div>Caractéristiques :</div>
                        <div
                          v-if="
                            devisObject.data.devis?.chauffe_eau
                              ?.have_certification
                          "
                        >
                          Les capteurs solaire ont une certification
                          <b>{{
                            devisObject.data.devis?.chauffe_eau
                              ?.nom_certification
                          }}</b>
                          reposant sur la norme
                          <b>
                            {{ devisObject.data.devis?.chauffe_eau?.norme }}</b
                          >.
                        </div>
                        <div>
                          La nature du fluide circulant dans les capteurs :<b>{{
                            devisObject.data.devis?.chauffe_eau?.nature_fluide
                          }}</b>
                        </div>
                        <div>
                          <b
                            >Note : Les capteurs solaires ne sont pas des
                            capteurs hybrides.</b
                          >
                        </div>
                        <div
                          v-for="(chantierItem, index) in group.products"
                          :key="index"
                        >
                          <div>
                            <div v-if="chantierItem.type_ligne === 'Product'">
                              <div>
                                Marque :
                                {{ chantierItem.fabricant }}
                              </div>
                              <div>
                                Réf :
                                {{ chantierItem.ref }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-TH-112'">
                    <div class="mt-3">
                      <div class="piece">
                        Appareil indépendant de chauffage au bois
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’un appareil indépendant de chauffage au
                        bois.

                        <div>Caractéristiques :</div>
                        <div
                          v-if="
                            devisObject.data.devis?.chauffage_au_bois
                              ?.flammeverte
                          "
                        >
                          <b>L'appareil possède le label flamme verte 7*</b>
                        </div>

                        <div>
                          Type de l'appareil :
                          {{ devisObject.data.devis?.chauffage_au_bois?.type }}
                        </div>
                        <div>
                          Le rendement énergétique et les émissions de polluants
                          ont été mesurés selon la norme
                          <b>{{
                            devisObject.data.devis?.chauffage_au_bois?.normes
                          }}</b
                          >.
                        </div>
                        <div>
                          L'appareil :
                          <b
                            v-if="
                              devisObject.data.devis?.chauffage_au_bois
                                ?.bois_granule
                            "
                            >sous forme de granulés</b
                          >
                          <b v-else>autre forme de granulés</b>.
                        </div>
                        <div
                          v-if="
                            !devisObject.data.devis?.chauffage_au_bois
                              ?.flammeverte
                          "
                        >
                          <div>
                            Les émissions de monoxyde de carbone (CO) :
                            <b
                              >{{
                                devisObject.data.devis?.chauffage_au_bois
                                  ?.emissions_CO
                              }}%</b
                            >
                          </div>
                          <div>
                            Les émissions d'oxydes d'azote (NOx) :
                            <b
                              >{{
                                devisObject.data.devis?.chauffage_au_bois
                                  ?.emissions_NOx
                              }}
                              mg</b
                            >
                          </div>
                          <div>Émissions de particules :</div>
                          <div>Rendement nominal de l’équipement :</div>
                        </div>

                        <div
                          v-for="(chantierItem, index) in group.products"
                          :key="index"
                        >
                          <div>
                            <div v-if="chantierItem.type_ligne === 'Product'">
                              <div>
                                Marque :
                                {{ chantierItem.fabricant }}
                              </div>
                              <div>
                                Réf :
                                {{ chantierItem.ref }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  
                
                  </div>
                  <div class="" v-if="group.type_group === 'BAR-TH-113'">
                    <div class="mt-3">
                      <div class="piece">
                        Chaudière biomasse individuelle
                      </div>
                      <div class="mx-4 mt-2">
                        Mise en place d’une chaudière biomasse individuelle.

                        <div>Caractéristiques :</div>
                        <div
                          v-if="
                            devisObject.data.devis?.chaudiere_biomasse
                              ?.flammeverte === 1
                          "
                        >
                          Label flamme verte <b>7*</b>
                        </div>
                        <div
                          v-if="
                            devisObject.data.devis?.chaudiere_biomasse
                              ?.flammeverte === 0
                          "
                        >
                          <div>
                            Les émissions saisonnière de particules :
                            {{
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.emissions_particules
                            }}
                            mg/Nm3
                          </div>
                          <div>
                            Les émissions saisonnière de monoxyde de carbone
                            (CO) :
                            {{
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.emissions_CO
                            }}
                            mg/Nm3
                          </div>
                          <div>
                            Ls émissions saisonnière d'oxydes d'azote (NOx) :
                            {{
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.emissions_NOx
                            }}
                            mg/Nm3
                          </div>
                          <div>
                            Les émissions saisonnière de composés organiques
                            gazeux :
                            {{
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.emissions_saisonère
                            }}
                            mg/Nm3
                          </div>
                        </div>
                        <div
                          v-if="
                            devisObject.data.devis?.chaudiere_biomasse
                              ?.type_alimentation === 'automatique'
                          "
                        >
                          Alimentation
                          <b>{{
                            devisObject.data.devis?.chaudiere_biomasse
                              ?.type_alimentation
                          }}</b
                          >, associée à un silo de stockage des granulés d'un
                          volume
                          <b>{{
                            devisObject.data.devis?.chaudiere_biomasse?.volume
                          }}</b>
                          litres.
                        </div>
                        <div
                          v-if="
                            devisObject.data.devis?.chaudiere_biomasse
                              ?.type_alimentation === 'manuel'
                          "
                        >
                          Alimentation
                          <b>
                            {{
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.type_alimentation
                            }}</b
                          >,
                          <b
                            v-if="
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.ballon_existant === 1
                            "
                            >associée à un ballon tampon
                          </b>
                          <b
                            v-if="
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.ballon_existant === 0
                            "
                            >n'est pas associée à un ballon tampon
                          </b>
                        </div>
                        <div>
                          Efficacité saisonnière :
                          <b
                            >{{
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.efficacite_energetique
                            }}%</b
                          >, selon le réglement (EU) 2015/1189 de la Commission
                          du 28 avril 2015
                        </div>
                        <div>
                          Puissance thermique nominale :
                          <b
                            >{{
                              devisObject.data.devis?.chaudiere_biomasse
                                ?.puissance
                            }}
                            kW</b
                          >.
                        </div>

                        <div>
                          Classe du régulateur :
                          <b>{{
                            devisObject.data.devis?.chaudiere_biomasse?.classe
                          }}</b>
                        </div>
                        <div>
                          - Absence de plaque signalétique de la chaudière à
                          remplacer.
                        </div>

                        <div
                          v-for="(chantierItem, index) in group.products"
                          :key="index"
                        >
                          <div>
                            <div v-if="chantierItem.type_ligne === 'Product'">
                              <div>
                                Marque :
                                {{ chantierItem.fabricant }}
                              </div>
                              <div>
                                Réf :
                                {{ chantierItem.ref }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="my-2 mx-4">
                      <div class="" v-if="group?.sous_traitant !== null">
                        Traveaux sous-traités auprès de l'entreprise
                        <b> {{ group?.sous_traitant?.name }}</b>
                      </div>
                      <div v-else class="">
                        Matériel(s) fourni(s) et mis en place par notre société
                        <b> {{ devisObject.data.devis.entreprise?.lib }}</b>
                      </div>
                      <div class="" v-if="group.sous_traitant !== null">
                        représentée par
                        {{ group.sous_traitant?.name }}
                        , SIRET
                        <b>
                          {{ group.sous_traitant?.num_siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div v-else class="">
                        représentée par
                        {{ devisObject.data.devis.entreprise?.lib }} , SIRET
                        <b>
                          {{ devisObject.data.devis.entreprise?.siret }}
                          ,</b
                        >
                        Certificat rge
                      </div>
                      <div class="">
                        Numéro
                        <b> {{ group.selected_certificat_RGE?.num }} </b>
                        attribué le
                        <b>
                          {{
                            formatDate(
                              group.selected_certificat_RGE?.date_attribution
                            )
                          }}
                        </b>
                        valable jusqu'au
                        <b>{{
                          formatDate(
                            group.selected_certificat_RGE?.date_expiration
                          )
                        }}</b
                        >, Assurance
                      </div>
                      <div class="">
                        civile
                        <b>
                          N°
                          {{
                            devisObject.data?.devis?.entreprise?.num_assurance
                          }}</b
                        >
                      </div>
                    </div>
                    <div class="mx-4" v-if="group?.cumac">
                      Cumac : <b>{{ group?.cumac }} kWh</b>
                    </div>
                  
                    
                  </div>
                  <div
                    class=""
                    v-if="isDevisLibre"
                  >
                    <div class="">
                      <div class="piece py-2">{{ group.traveaux }}</div>
                      <div class="mx-4 mt-2" v-html="group.description"></div>
                    </div>
                  </div>
                  <div style="overflow-x: auto">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>{{ $t("REF") }}</th>
                          <th>{{ $t("WORDING") }} && {{ $t("DESC") }}</th>
                          <th>{{ $t("QTE") }}</th>
                          <th>{{ $t("UNITEU") }}</th>
                          <th>{{ $t("PUHT") }}</th>
                          <th>{{ $t("TOTALHT") }}</th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="(product, index) in group.products"
                        :key="index"
                      >
                        <tr>
                          <!-- Ligne principale -->
                          <td>
                            <b>{{ product.ref }}</b>
                          </td>
                          <td class="descblock">
                            <b>{{ product.lib }}</b>
                            <div class="descblock" v-html="product.desc"></div>
                          </td>
                          <td>{{ product.quantite }}</td>
                          <td>{{ product.type_unite }}</td>
                          <td>{{ product.unit_price }} €</td>
                          <td>{{ formatDecimal(product.unit_price * product.quantite, 3) }}  €</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="flexEndTotale"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="flexEndTotale">
          <div class="subtableTotale">
            <table class="completTotale">
              <tr>
                <td class="theadTotale">
                  {{ $t("TOTAL_HT") }}
                </td>
                <td>{{ formatNumber(devisObject.data?.total_HT) }} €</td>
              </tr>

              <template v-if="filteredTvaDocuments.length">
                <tr v-for="tva in filteredTvaDocuments" :key="'tva' + tva.id">
                  <td class="theadTotale">TVA ({{ tva?.tva }}%)</td>
                  <td style="border-radius: 0px 5px 0px 0px">
                    {{ formatNumber(tva?.tva_montant) }}
                  </td>
                </tr>
              </template>

              <tr>
                <td class="theadTotale">
                  {{ $t("Total TTC") }}
                </td>
                <td>{{ formatNumber(devisObject.data?.total_TTC) }} €</td>
              </tr>
              <tr v-if="hasCertificatEconomieEnergie">
                <td class="theadTotale">
                  {{ $t("Prime CEE") }}
                </td>
                <td>{{ formatNumber(sommeMontantsParGroupe(devisObject,"montant_cee")) }} €</td>
              </tr>
              <tr v-if="hasMaPrimeRenove">
                <td class="theadTotale">
                  {{ $t("Anah") }}
                </td>
                <td>{{ formatNumber(sommeMontantsParGroupe(devisObject,"MPR")) }} €</td>
              </tr>
              <tr v-if="hasCoupDePouce ">
                <td class="theadTotale">
                  {{ $t("coup De Pouce") }}
                </td>
                <td>{{ formatNumber(sommeMontantsParGroupe(devisObject, "coupDePouce")) }} €</td>
              </tr>

              <tr>
                <td class="theadTotale">
                 RAC
                </td>
                <td>{{ formatNumber(calculRAC) }} €</td>
              </tr>
            </table>
          </div>
        </div>
        <div
          class="part mt-3"
          v-if="isDevisLibre"
        >
          <div>
            <b>{{ $t("REMARQUE") }}</b
            >/<b>{{ $t("COND_REG") }}</b>
          </div>
          <div
            class="mx-4 mt-2"
            v-html="devisObject.data.devis?.remarque"
          ></div>
          <!-- <div>
            <p>{{ devisObject.data.devis?.remarque }}</p>
          </div> -->
          <!-- <div >
            <p>{{ devisObject.data.devis?.conditions_reglements }}</p>
          </div> -->
        </div>
        <div
          class="part mt-3"
          v-if="!isDevisLibre"
        >
          <div><b>Termes et conditions CEE</b></div>
          <div v-if="devisObject.data.devis?.mandataire">
            <p v-html="replacePlaceholders(devisObject.data.devis?.mandataire?.paragraphCEE)"></p>
          </div>
          <div v-if="!devisObject.data.devis?.mandataire">
            <p v-html="replacePlaceholders(devisObject.data.devis?.partenaire?.paragraphCEE)"></p>
          </div>

          <div v-if="devisObject.data.devis?.mandataire?.paragraphMaPrimeRenov && moyens_paiement.includes('Ma_prime_renove')">
            <div><b>Termes et conditions Ma Prime Renov</b></div>
            <p v-html="replacePlaceholders(devisObject.data.devis?.mandataire?.paragraphMaPrimeRenov)"></p>
          </div>
          <div v-if="!devisObject.data.devis?.mandataire && devisObject.data.devis?.partenaire?.paragraphMaPrimeRenov && moyens_paiement.includes('Ma_prime_renove')">
            <div><b>Termes et conditions Ma Prime Renov</b></div>
            <p v-html="replacePlaceholders(devisObject.data.devis?.partenaire?.paragraphMaPrimeRenov)"></p>
          </div>
        </div>

        <div class="part mt-3">
          <div>
            {{ $t("MOD_PAYMENT") }} :
            <div v-if="moyens_paiement.length === 0">
              Aucun moyen de paiement disponible.
            </div>
            <div v-else>
              <span
                v-for="(paiement, index) in moyens_paiement"
                :key="paiement.id"
              >
                <b v-if="paiement.moyen_paiement === 'Organisme_de_financement'"
                  >Organisme de financement</b
                >
                <b v-if="paiement.moyen_paiement === 'cheque_virement_espece'"
                  >Chèque virement espèce</b
                >
                <b
                  v-if="
                    paiement.moyen_paiement === 'Certificat_Economie_energie'
                  "
                  >Certificat d'Économie d'énergie (CEE)</b
                >
                <b v-if="paiement.moyen_paiement === 'Ma_prime_renove'"
                  >Ma prime rénove (MPR)</b
                >
                    <b v-if="paiement.moyen_paiement === 'coupDePouce'"
                  >Coup de pouce</b
                >
                <b v-if="paiement.moyen_paiement === 'Autre'">Autre</b>
                <span v-if="index < moyens_paiement.length - 1"> / </span>
              </span>
            </div>
          </div>

          <h3
            v-if="
              +devisObject.data?.devis?.montant_maprimrenov &&
              devisObject.data?.devis?.with_aide
            "
          >
            <span class="part-title"> {{ $t("MA_PRIME_RENOV") }}: </span>

            <span>{{
              devisObject.data?.devis?.montant_maprimrenov | financial
            }}</span>
          </h3>
        </div>
      </div>

      <b-modal
        id="factureTypeModal"
        v-model="showFactureModal"
        hide-footer
        centered
        :title="$t('Sélectionner un type de facture') || 'Sélectionner un type de facture'"
        title-class="facture-modal-title"
        dialog-class="facture-modal-dialog"
        body-class="facture-modal-body"
      >
        <b-form-group :label="$t('Type de facture') || 'Type de facture'">
          <b-form-select
            v-model="factureType"
            :options="factureTypeSelectOptions"
            :placeholder="$t('Choisir...') || 'Choisir...'"
          ></b-form-select>
        </b-form-group>
        <div class="text-right mt-5 facture-modal-actions">
          <b-button variant="secondary" class="mr-2" @click="closeFactureModal">
            {{ $t("CANCEL") }}
          </b-button>
          <b-button
            variant="success"
            :disabled="!factureType"
            @click="confirmFactureType"
          >
            {{ $t("VALIDATE") || $t("CONFIRM") }}
          </b-button>
        </div>
      </b-modal>

      <div class="mt-3">
        <div class="d-flex justify-content-center">
          {{ devisObject.data.devis.entreprise.lib }} -
          {{ devisObject.data.devis.entreprise.rue }} - au capital de
          {{ devisObject.data.devis.entreprise.cp }} Siret :{{
            devisObject.data.devis.entreprise.siret
          }}
          - N° {{ devisObject.data.devis.entreprise?.num_tva }}
        </div>
        <div class="d-flex justify-content-center">
          Courriel :
          {{ devisObject.data.devis.entreprise.email }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import domain from "@/environment";

import { domains } from "@/environment";
import { mapActions, mapGetters, mapState } from "vuex";
import axios from "axios";
export default {
  props: {
    documentType: {
      type: String,
      default: null, // null means auto-detect from isFactureDocument
      validator: function(value) {
        return value === null || value === "devis" || value === "facture";
      },
    },
  },
  data() {
    return {
      renovation: "renovation d'ampleur",
      readActivated: [
        {
          bool: false,
        },
      ],
      galleryUrl: domains.gallery,
      moyens_paiement: [],
      signedLoader: null,
      downloadLoader: false,
      pdfInfo: null,
      rest: null,

      downloadUrl: domains.download,
      editLoader: false,
      devisObject: {
        data: {
          devis: {
            brouillon: 1,
            product_to_delete: [],
            groups_to_add: [
              {
                type_traveaux_id: 1,
                type_piece_id: 1,
                piece: "ss",
                traveaux: "FIC",
                produits: [],
              },
            ],
          },
        },
      },
      devisObjectLoaded: false,
      showFactureModal: false,
      factureType: null,
      factureTypeOptions: [
        { value: "facture.acompte", text: "Facture d'acompte" },
        { value: "facture.fin-travaux", text: "Facture finale" },
      ],
      selectedStatus: null,
      statusUpdateLoading: false,
      statusList: [
        "devis_en_cours",
        "devis_signe",
        "pose_a_planifier",
        "pose_en_cours",
        "pose_termine",
        "controle_a_planifier",
        "en_traitement_administratif",
        "dossier_a_deposer",
        "dossier_depose",
        "dossier_paye",
      ],

    };
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
    }),
    ...mapGetters([
      "devisObjectObject",
      "getOnlineUser",
      "getcreationEntreprise",
    ]),
    devisEnIpsrFluideNum() {
      const ipsr = this.devisObject?.data?.devis?.isolation_points_singuliers_reseau;
      if (!ipsr || ipsr.fluide == null || ipsr.fluide === "") return null;
      const n = Number(ipsr.fluide);
      return isNaN(n) ? null : n;
    },
    filteredTvaDocuments() {
      return (
        this.devisObject.data?.tva_document?.filter((tva) => tva.tva !== 0) ||
        []
      );
    },
    devisEnIpsrDnNum() {
      const ipsr = this.devisObject?.data?.devis?.isolation_points_singuliers_reseau;
      if (!ipsr || ipsr.diametre_nominal_dn == null || ipsr.diametre_nominal_dn === "") return null;
      const n = Number(ipsr.diametre_nominal_dn);
      return isNaN(n) ? null : n;
    },
    devisEnIpsrNByDn() {
      const ipsr = this.devisObject?.data?.devis?.isolation_points_singuliers_reseau;
      const dn = this.devisEnIpsrDnNum;
      const value = ipsr?.nombre_housses ?? null;
      if (!ipsr || dn == null) return { label: "", value };
      if (dn >= 20 && dn <= 65) return { label: "Température 50°C ≤ Tfluide ≤ 120°C – 20 ≤ DN ≤ 65", value };
      if (dn > 65 && dn <= 100) return { label: "Température 50°C ≤ Tfluide ≤ 120°C – 65 < DN ≤ 100", value };
      if (dn > 100) return { label: "Température 50°C ≤ Tfluide ≤ 120°C – 100 < DN", value };
      return { label: "", value };
    },
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    isentrepriseAdmin() {
      return this.getOnlineUser.role == "user.entreprise-admin";
    },
    isAssistant() {
      return this.getOnlineUser.role == "user.assistant";
    },
    isCommercial() {
      return this.getOnlineUser.role == "user.commercial-entreprise";
    },
    isClient() {
      return this.getOnlineUser.role == "user.client";
    },
    onlineUser() {
      return this.getOnlineUser;
    },
    hasCertificatEconomieEnergie() {
      return this.moyens_paiement.some(
        (paiement) => paiement.moyen_paiement === "Certificat_Economie_energie"
      );
    },
    hasMaPrimeRenove() {
      return this.moyens_paiement.some(
        (paiement) => paiement.moyen_paiement === "Ma_prime_renove"
      );
    },
    hasCoupDePouce() {
      return this.moyens_paiement.some(
        (paiement) => paiement.moyen_paiement === "coupDePouce"
      );
    },
    documentMeta() {
      const root = this.devisObject?.data?.devis || {};
      const nested = root?.devis || {};
      return {
        type: nested.type || root.type || "",
        factureNumber:
          nested.numerofacture || root.numerofacture || root?.facture?.numerofacture || null,
        devisNumber:
          nested.numerodevis || root.numerodevis || root?.devis?.numerodevis || null,
      };
    },
    isFactureDocument() {
      const type = (this.documentMeta.type || "").toLowerCase();
      return type.includes("facture");
    },

    documentLabelKey() {
      if (this.isFactureView) {
        const typeFacture =
          this.devisObject?.data?.devis?.typeFacture ||
          this.devisObject?.data?.devis?.type_facture;
        if (typeFacture === "facture.acompte") {
          return "ACOMPTE";
        }
        return "FACTURE";
      }
      return "DEVIS";
    },
    documentLabel() {
      return this.$t(this.documentLabelKey);
    },
    documentNumber() {
      if (this.isFactureView) {
        return (
          this.documentMeta.factureNumber ||
          this.documentMeta.devisNumber ||
          "-"
        );
      }
      return (
        this.documentMeta.devisNumber ||
        this.documentMeta.factureNumber ||
        "-"
      );
    },
    factureNumberValue() {
      return this.documentMeta.factureNumber;
    },
    devisNumberValue() {
      return this.documentMeta.devisNumber;
    },
    hasFactureNumber() {
      return !!this.factureNumberValue;
    },
    isAcompteFacture() {
      const typeFacture =
        this.devisObject?.data?.devis?.typeFacture ||
        this.devisObject?.data?.devis?.type_facture;
      return typeFacture === "facture.acompte";
    },
    calculRAC() {
      const totalTTC = parseFloat(this.devisObject.data?.total_TTC || 0);
      const montantASoustraire = this.calculerMontantASoustraire();
      const resultat = totalTTC - montantASoustraire;
      // Retourner 0 si le résultat est négatif
      return resultat < 0 ? 0 : resultat;
    },
    factureTypeSelectOptions() {
      const placeholder = this.$t("Choisir") || "Choisir...";
      return [
        { value: null, text: placeholder, disabled: true },
        ...this.factureTypeOptions,
      ];
    },
    isBrouillon() {
      return this.devisObject?.data?.brouillon === 1 || this.devisObject?.data?.devis?.brouillon === 1;
    },
    routeType() {
      // Récupérer le type depuis le router (query ou params)
      return this.$route?.query?.type || this.$route?.params?.type || null;
    },
    resolvedRouteType() {
      const type = String(this.routeType || "").toLowerCase();
      return type === "devis" || type === "facture" ? type : null;
    },
    effectiveDocumentType() {
      return (
        this.resolvedRouteType ||
        this.documentType ||
        (this.isFactureDocument ? "facture" : "devis")
      );
    },
    isFactureView() {
      return this.effectiveDocumentType === "facture";
    },
    shouldShowDevisDates() {
      // Afficher les dates de devis si le type est "devis" ou si c'est null/undefined (par défaut)
      const type = this.routeType || this.documentType;
      return !type || type === "devis" || (!this.isFactureDocument && !type);
    },
    isDevisLibre() {
      const typeDevis = this.devisObject?.data?.devis?.type_devis;
      const groups = this.devisObject?.data?.groupeLigneDocument || [];
      return (
        typeDevis === "Libre" ||
        typeDevis === "Batigo" ||
        groups.some(
          (g) => g.type_group === "Libre" || g.type_group === "Batigo"
        )
      );
    },
    shouldShowVisiteTechnique() {
      return this.shouldShowDevisDates && (this.devisNumberValue || this.isDevisLibre);
    },
    shouldShowFactureDates() {
      // Afficher les dates de facture uniquement si le paramètre du router contient type=facture
      const type = this.routeType || this.documentType;
      return type === "facture";
    },
  },
  watch: {
    devisObject: {
      handler() {},
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "updatedevis",
      "getoneMonodevis",
      "downloadDevis",
      "email_devis",
      "signed_devis",
      "updateCreationEntreprise",
    ]),
     sommeMontantsParGroupe(devisObject,Objectdat) {
 
  const sommeTotale = devisObject.data.groupeLigneDocument.reduce((somme, groupe) => {
    const montant =  parseFloat(groupe?.[Objectdat], 10) || 0;
    return somme + montant;
  }, 0);

  return sommeTotale;
},
    formatNumber(value) {
      if (value === null || value === undefined) return "0.00";
      const num = parseFloat(value);
      if (isNaN(num)) return "0.00";
      return num.toFixed(2);
    },
    formatTypeIsolant(value) {
      if (!value) return value;
      if (value === "reflechesson_et_non_reflichessant") {
        return "reflechesson et non reflichessant";
      }
      return value;
    },
    replacePlaceholders(text) {
      if (!text) return '';
      
      let result = text;
      
      // Remplacer {{MONTANTPRIMECEE}} ou {{montantPrimeCEE}} par le montant CEE
      const montantCEE = this.sommeMontantsParGroupe(this.devisObject, "montant_cee");
      result = result.replace(/\{\{MONTANTPRIMECEE\}\}/gi, montantCEE.toFixed(2) + ' €');
      result = result.replace(/\{\{montantPrimeCEE\}\}/g, montantCEE.toFixed(2) + ' €');
      
      // Remplacer {{MONTANTANNAH}} ou {{montantANNAH}} par le montant Ma Prime Renov
      const montantMPR = this.sommeMontantsParGroupe(this.devisObject, "MPR");
      result = result.replace(/\{\{MONTANTANNAH\}\}/gi, montantMPR.toFixed(2) + ' €');
      result = result.replace(/\{\{montantANNAH\}\}/g, montantMPR.toFixed(2) + ' €');
      
      return result;
    },
    calculerMontantASoustraire() {
      let montantTotal = 0;
      
      // Vérifier et ajouter CEE si le moyen de paiement est sélectionné
      if (this.hasCertificatEconomieEnergie) {
        montantTotal += this.sommeMontantsParGroupe(this.devisObject, "montant_cee");
      }
      
      // Vérifier et ajouter MPR si le moyen de paiement est sélectionné
      if (this.hasMaPrimeRenove) {
        montantTotal += this.sommeMontantsParGroupe(this.devisObject, "MPR");
      }
      
      // Vérifier et ajouter Coup de Pouce si le moyen de paiement est sélectionné
      if (this.hasCoupDePouce) {
        montantTotal += this.sommeMontantsParGroupe(this.devisObject, "coupDePouce");
      }
      
      return montantTotal;
    },
    facture(typeFacture) {
      if (!typeFacture) {
        this.factureType = null;
        this.showFactureModal = true;
        return;
      }
      this.processFacture(typeFacture);
    },
    closeFactureModal() {
      this.showFactureModal = false;
      this.factureType = null;
    },
    confirmFactureType() {
      if (!this.factureType) {
        return;
      }
      this.showFactureModal = false;
      this.processFacture(this.factureType);
    },
    async processFacture(selectedType) {
      const devis = this.devisObject?.data?.devis;
      if (!devis?.id) {
        return;
      }

      const payload = {
        id: devis.id,
        type: "facture",
        typeFacture: selectedType,
      };

      try {
        await this.updatedevis(payload);
        const documentId = this.$route.params.id || this.devisObject.data?.id;
        if (documentId) {
          await this.fetchDevisObject(documentId);
        }
        // Toast de succès
        this.$bvToast && this.$bvToast.toast(
           "La facture a été bien générée",
          {
            title: this.$t("SUCCESS") || "Succès",
            variant: "success",
            autoHideDelay: 4000,
          }
        );
      } catch (error) {
        console.error("Error updating devis to facture:", error);
        this.$bvToast && this.$bvToast.toast(
          error?.response?.data?.message ||
            error?.message ||
            "Erreur lors de la transformation en facture.",
          {
            title: this.$t("ERROR") || "Erreur",
            variant: "danger",
            autoHideDelay: 4000,
          }
        );
      } finally {
        this.factureType = null;
      }
    },
    async convertAcompteToFinal() {
      if (!this.isAcompteFacture) {
        return;
      }
      await this.processFacture("facture.fin-travaux");
    },
    openfac() {
      var facture = this.devisObject.data.devis.facture;
      this.$router.push("/facture/list?id=" + facture.id);
    },
    breakText(text) {
      const chunkSize = 27;
      const regex = new RegExp(`.{1,${chunkSize}}`, "g");
      return text.match(regex) || [];
    },

    calculeRest() {
      const res =
        this.devisObject.data.total_TTC -
        this.devisObject.data.devis.montant_cee;
      return res.toFixed(3);
    },
    sendEmail() {
      this.email_devis(this.devisObject.data.devis.id)
        .then(() => {
          this.box = "";
          this.$bvModal.msgBoxOk(this.$t("INVOICE_SENDED"), {
            title: "Confirmation",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            centered: true,
          });
        })
        .catch(() => {});
    },

    showMsgBox() {
      this.box = "";
      this.$bvModal
        .msgBoxConfirm(`${this.$t("YOUSIGN_SENDED_WARNIN")}`, {
          title: `${this.$t("CONFIRM")}`,
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          okTitle: `${this.$t("YES")}`,
          cancelTitle: `${this.$t("NO")}`,
          footerClass: "p-2",
          hideHeaderClose: false,
        })
        .then((value) => {
          if (value) {
            this.signed_devis({
              id: this.devisObject.data.devis.id,
              doc: this.devisObject.data.id,
            })
              .then(() => {
                this.box = "";
                this.$bvModal.msgBoxOk(this.$t("YOUSIGN_SENDED"), {
                  title: "Confirmation",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  centered: true,
                });
              })
              .catch(() => {
                this.erreur = this.getErreur;
              });
          }
        });
    },
    generateFacture(devis) {
        this.downloadLoader = true;
      var id = 0;

      if (!devis) {
        id = this.devisObject.data.devis.id;
        console.log('id',id)
      } else {
        id = devis.devis.id;
      }
      this.downloadDevis({ id, type: "facture" })
        .then((response) => {
          this.downloadLoader = false;
          this.pdfInfo = response;
          this.download();
        })
        .catch(() => {
          this.downloadLoader = false;
        });
    },
    generate(devis) {
      this.downloadLoader = true;
      var id = 0;
      if (!devis) {
        id = this.devisObject.data.devis.id;
      } else {
        id = devis.devis.id;
      }
      this.downloadDevis({ id, type: "devis" })
        .then((response) => {
          this.downloadLoader = false;
          this.pdfInfo = response;
          this.download();
        })
        .catch(() => {
          this.downloadLoader = false;
        });
    },
    async signed() {
      if (this.devisObject.data.is_signed != "pending") {
        this.signedLoader = true;
        await this.signed_devis({
          id: this.devisObject.data.devis.id,
          doc: this.devisObject.data.id,
        })
          .then(() => {
            this.box = "";
            this.signedLoader = false;
            this.$bvModal.msgBoxOk(this.$t("YOUSIGN_SENDED"), {
              title: "Confirmation",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              centered: true,
            });
          })
          .catch(() => {
            this.signedLoader = false;
            this.erreur = this.getErreur;
          });
      } else {
        this.showMsgBox();
      }
    },
    handleUpdate() {
      this.editLoader = true;

      this.getoneMonodevis(this.devisObject.data.devis.id)
        .then(() => {
          this.editLoader = false;

          const { id, type_devis } = this.devisObject.data.devis;
          const basePath = `/devis`;
          const complexTypes = [
            "Type Complexe",
            "BAR-TH-101",
            "BAR-EN-101",
            "BAR-EN-102",
            "BAR-EN-104",
            "BAR-EN-103",
            "BAR-TH-112",
            "BAR-TH-113",
            "BAR-TH-171",
            "BAR-TH-143",
            "BAR-TH-127",
            "BAR-TH-129",
            "BAR-TH-137",
            "BAR-TH-148",
            "BAR-TH-173",
            "BAR-TH-161",
            "BAR-SE-108",
            "renovation d'ampleur",
            "BAT-TH-142"
            // "BAR-TH-174",
            // "BAR-TH-175",
          ];

          let path = "";
          if (complexTypes.includes(type_devis)) {
            path = `${basePath}/update/${id}`;
          } else if (["Libre", "Batigo"].includes(type_devis)) {
            path = `${basePath}/manuel/${id}`;
          }

          if (path) {
            this.$router.push({ path });
          }

          this.updateCreationEntreprise(false);
        })
        .catch(() => {
          this.editLoader = false;
        });
    },
    download() {
      if (this.pdfInfo.document.is_signed == "stored")
        window.open(this.pdfInfo.pdf, "_blank");
      else window.open(this.downloadUrl + this.pdfInfo.pdf, "_blank");
    },
    async downloadEntreprisesPdf() {
      this.downloadLoader = true;
      const id = this.devisObject.data.devis.id;
      try {
        const response = await axios.get(
          domain + `/devis/entreprises-pdf/` + id,
          {
            headers: {
              Authorization: `Bearer ` + this.token,
            },
          }
        );
        this.downloadLoader = false;
        const pdfData = response.data.data;
        // Ouvrir le PDF directement avec l'URL de téléchargement fournie par l'API
        if (pdfData.download_url) {
          window.open(pdfData.download_url, "_blank");
        } else {
          console.error("No download URL in response");
        }
      } catch (error) {
        this.downloadLoader = false;
        console.error("Error downloading entreprises PDF:", error);
      }
    },

    async fetchDevisObject(id) {
      this.devisObject = await this.getoneMonodevis(id);
      if (this.devisObject.data && this.devisObject.data.devis) {
        // Don't force brouillon to 1, use the actual value from API
        // Initialize selected status from devis object
        // Logic: 
        // - Default (creation): "devis_en_cours"
        // - If brouillon = 0: "devis_signe"
        // - If brouillon = 1: "devis_en_cours"
        
        const brouillonValue = this.devisObject.data.brouillon !== null && this.devisObject.data.brouillon !== undefined 
          ? this.devisObject.data.brouillon 
          : (this.devisObject.data.devis.brouillon !== null && this.devisObject.data.devis.brouillon !== undefined 
            ? this.devisObject.data.devis.brouillon 
            : null);
        
        // Check if there's already a status from API
        let apiStatus = this.devisObject.data.devis.status || 
                       this.devisObject.data.devis.statut || 
                       this.devisObject.data.status || 
                       null;
        
        // IMPORTANT: Always preserve existing status from API, never overwrite or reset it
        // If there's a status from API, ALWAYS use it (even if brouillon=0)
        if (apiStatus) {
          // Normalize status format (convert spaces to underscores if needed)
          let normalizedStatus = String(apiStatus).trim().replace(/\s+/g, '_').toLowerCase();
          console.log("Normalizing status:", apiStatus, "->", normalizedStatus);
          
          // Check if the normalized status exists in our list
          if (this.statusList.includes(normalizedStatus)) {
            // Status exists and is valid, preserve it
            this.selectedStatus = normalizedStatus;
            console.log("Status found in list, preserving existing status:", normalizedStatus);
          } else {
            // If not found, try to find a match (case-insensitive)
            const foundStatus = this.statusList.find(s => s.toLowerCase() === normalizedStatus.toLowerCase());
            if (foundStatus) {
              this.selectedStatus = foundStatus;
              console.log("Status matched (case-insensitive), preserving existing status:", foundStatus);
            } else {
              // If still not found but we have a status from API, use it as-is (preserve it)
              // Don't reset to default - the status exists in API and should be kept
              this.selectedStatus = normalizedStatus;
              console.log("Status not in list but exists in API, preserving as-is:", normalizedStatus);
            }
          }
        } else {
          // No status from API - only set default when status is truly missing
          // IMPORTANT: Only set defaults when status doesn't exist, never overwrite existing status
          if (brouillonValue === 0) {
            // If brouillon is 0 and no status exists, default to "devis_signe"
            console.log("No status from API, defaulting to devis_signe (brouillon = 0)");
            this.selectedStatus = "devis_signe";
          } else {
            // Default to "devis_en_cours" (creation or brouillon = 1 or null)
            console.log("No status from API, defaulting to devis_en_cours (creation or brouillon = 1)");
            this.selectedStatus = "devis_en_cours";
          }
        }
      }

      this.rest = this.calculeRest();

      this.devisObjectLoaded = true;
    },
    cycleStatus() {
      console.log("cycleStatus called!");
      console.log("statusUpdateLoading:", this.statusUpdateLoading);
      console.log("isBrouillon:", this.isBrouillon);
      
      if (this.statusUpdateLoading) {
        console.log("cycleStatus - blocked: statusUpdateLoading is true");
        return;
      }

      // Don't allow status change if devis is in brouillon
      if (this.isBrouillon) {
        console.log("cycleStatus - blocked: devis is in brouillon");
        return;
      }

      if (!this.devisObject || !this.devisObject.data || !this.devisObject.data.devis || !this.devisObject.data.devis.id) {
        return;
      }

      // If no status selected, start with "devis_en_cours"
      if (!this.selectedStatus) {
        console.log("CycleStatus - No status selected, starting with devis_en_cours");
        this.selectedStatus = "devis_en_cours";
        // Update immediately in devisObject
        if (this.devisObject && this.devisObject.data && this.devisObject.data.devis) {
          this.devisObject.data.devis.status = "devis_en_cours";
        }
        this.updateDevisStatus();
        return;
      }

      // Find current status index in the list
      let currentIndex = -1;
      if (this.selectedStatus) {
        currentIndex = this.statusList.findIndex(status => status === this.selectedStatus);
      }
      
      console.log("CycleStatus - Current status:", this.selectedStatus);
      console.log("CycleStatus - Current index:", currentIndex);
      console.log("CycleStatus - Status list:", this.statusList);
      
      // Get next status index (cycle to first if at the end)
      let nextIndex;
      if (currentIndex === -1) {
        // If status not found in list, start from the beginning
        console.log("CycleStatus - Status not found in list, starting from beginning");
        nextIndex = 0;
      } else if (currentIndex >= this.statusList.length - 1) {
        // If at the end, cycle back to first
        console.log("CycleStatus - At end of list, cycling to first");
        nextIndex = 0;
      } else {
        // Move to next status
        nextIndex = currentIndex + 1;
        console.log("CycleStatus - Moving to next index:", nextIndex);
      }

      // Set new status immediately for UI update
      const newStatus = this.statusList[nextIndex];
      console.log("CycleStatus - Setting new status:", newStatus);
      
      // Update selectedStatus immediately so UI reflects the change
      this.selectedStatus = newStatus;
      
      console.log("CycleStatus - Selected status set to:", this.selectedStatus);
      
      // Also update in devisObject for consistency
      if (this.devisObject && this.devisObject.data && this.devisObject.data.devis) {
        this.devisObject.data.devis.status = newStatus;
      }
      
      console.log("CycleStatus - About to call updateDevisStatus");
      
      // Update status via API (async, but UI already updated)
      this.updateDevisStatus().catch(error => {
        console.error("CycleStatus - Error updating status:", error);
      });
    },
    /** Indique si le devis est signé : uniquement si is_signed n'est pas null. Utilise devisObject.data directement. */
    isDevisSigned() {
      const d = this.devisObject?.data;
      if (!d) return false;
      const isSignedValue = d.is_signed;
      return (isSignedValue != null && isSignedValue !== '');
    },
    /** Statut affiché en lecture seule : brouillon → Brouillon, signé → Devis signé (si is_signed != null), sinon → Non signé. */
    getDisplayStatusText() {
      const isFacture = this.documentType === "facture" || 
                       (this.documentType === null && this.isFactureDocument);
      const d = this.devisObject?.data;
      if (!d) return isFacture ? this.$t("Non signée") || "Non signée" : this.$t("Non signé") || "Non signé";
      const brouillon = d.brouillon === 1 || d.brouillon === true;
      // Signé uniquement si is_signed n'est pas null
      const isSigned = d.is_signed != null && d.is_signed !== '';
      if (brouillon) return isFacture ? this.$t("Facture en cours") || "Facture en cours" : this.$t("Brouillon") || "Brouillon";
      if (isSigned) return isFacture ? this.$t("Facture signée") || "Facture signée" : this.$t("Devis signé") || "Devis signé";
      return isFacture ? this.$t("Non signée") || "Non signée" : this.$t("Non signé") || "Non signé";
    },
    getCurrentStatusText() {
      // Determine if this is a facture: use prop if provided, otherwise auto-detect
      const isFacture = this.documentType === "facture" || 
                       (this.documentType === null && this.isFactureDocument);
      
      // If devis is in brouillon, show appropriate text based on document type
      if (this.isBrouillon) {
        return isFacture ? "Facture en cours" : "Devis en cours";
      }
      
      if (!this.selectedStatus) {
        return this.$t("NO_STATUS") || "Aucun statut";
      }
      // Map status values to display text
      // For factures, display "Facture en cours" for "devis_en_cours" and "Facture signée" for "devis_signe"
      const statusMap = {
        "devis_en_cours": isFacture ? "Facture en cours" : "Devis en cours",
        "devis_signe": isFacture ? "Facture signée" : "Devis signé",
        "pose_a_planifier": "Pose à planifier",
        "pose_en_cours": "Pose en cours",
        "pose_termine": "Pose terminé",
        "controle_a_planifier": "Contrôle à planifier",
        "en_traitement_administratif": "En traitement administratif",
        "dossier_a_deposer": "Dossier à déposer",
        "dossier_depose": "Dossier déposé",
        "dossier_paye": "Dossier payé",
      };
      return statusMap[this.selectedStatus] || this.selectedStatus;
    },
    getStatusBadgeStyle() {
      // Affichage lecture seule : brouillon = rouge, signé = vert (si is_signed != null), non signé = gris.
      const d = this.devisObject?.data;
      if (!d) return { 'background-color': '#6c757d', 'color': '#ffffff' };
      const brouillon = d.brouillon === 1 || d.brouillon === true;
      // Signé uniquement si is_signed n'est pas null
      const isSigned = d.is_signed != null && d.is_signed !== '';
      if (brouillon) return { 'background-color': '#dc3545', 'color': '#ffffff' }; // Brouillon: rouge
      if (isSigned) return { 'background-color': '#28a745', 'color': '#ffffff' };  // Signé: vert
      return { 'background-color': '#6c757d', 'color': '#ffffff' };                 // Non signé: gris
    },
    async updateDevisStatus() {
      if (!this.devisObject || !this.devisObject.data || !this.devisObject.data.devis || !this.devisObject.data.devis.id) {
        return;
      }

      // Store previous status for rollback (use selectedStatus as it's the current state)
      const previousStatus = this.selectedStatus;

      this.statusUpdateLoading = true;
      try {
        // Create payload with all devis data and update status
        // We need to handle brouillon separately to ensure it's a boolean (0 or 1)
        const devisData = { ...this.devisObject.data.devis };
        
        // Extract brouillon and remove it from devisData to avoid null values
        const { brouillon: brouillonFromDevis, ...devisDataWithoutBrouillon } = devisData;
        
        // Handle brouillon: get from devisObject.data.brouillon first (as user mentioned this is the source), then from devis
        // IMPORTANT: Preserve existing brouillon value - if it's 0, keep it 0; if it's 1, keep it 1
        // NEVER change brouillon from 0 to 1 during update
        let brouillonValue = null;
        
        // Check devisObject.data.brouillon first (as user mentioned this is the source)
        if (this.devisObject.data.brouillon !== null && this.devisObject.data.brouillon !== undefined) {
          brouillonValue = this.devisObject.data.brouillon === 1 || this.devisObject.data.brouillon === true ? 1 : 0;
        }
        // Then check devis.brouillon
        else if (brouillonFromDevis !== null && brouillonFromDevis !== undefined) {
          brouillonValue = brouillonFromDevis === 1 || brouillonFromDevis === true ? 1 : 0;
        }
        
        // IMPORTANT: Preserve brouillon value exactly as it is
        // If brouillon is 0, it stays 0; if 1, it stays 1; if null, default to 0
        // This ensures that once brouillon=0, it never goes back to 1
        const finalBrouillonValue = brouillonValue !== null && brouillonValue !== undefined ? brouillonValue : 0;
        
        const updatePayload = {
          ...devisDataWithoutBrouillon,
          id: this.devisObject.data.devis.id,
          status: this.selectedStatus || null,
          brouillon: finalBrouillonValue, // Preserve existing brouillon value (0 stays 0, 1 stays 1), never null
        };
        
        console.log("UpdateDevisStatus - Payload:", updatePayload);
        console.log("UpdateDevisStatus - Selected status:", this.selectedStatus);
        console.log("UpdateDevisStatus - Brouillon value:", brouillonValue);
        console.log("UpdateDevisStatus - devisObject.data.brouillon:", this.devisObject.data.brouillon);
        
        const response = await this.updatedevis(updatePayload);
        
        console.log("UpdateDevisStatus - Response:", response);
        
        // Update local devisObject with response data
        if (response && response.data && response.data.data) {
          const updatedDevis = response.data.data;
          
          // Update status in devis object
          if (updatedDevis.status !== undefined) {
            this.devisObject.data.devis.status = updatedDevis.status;
          }
          // Also check nested structure
          if (updatedDevis.devis && updatedDevis.devis.status !== undefined) {
            this.devisObject.data.devis.status = updatedDevis.devis.status;
          }
          
          // Ensure selectedStatus is synchronized
          const newStatus = updatedDevis.status || updatedDevis.devis?.status || this.selectedStatus;
          this.selectedStatus = newStatus;
          
          console.log("UpdateDevisStatus - Status updated to:", this.selectedStatus);
        } else {
          // If response structure is different, still update selectedStatus locally
          this.devisObject.data.devis.status = this.selectedStatus;
          console.log("UpdateDevisStatus - Updated locally to:", this.selectedStatus);
        }
        
        // Show success message (optional, can be removed if too many notifications)
        // this.$bvToast.toast(this.$t("STATUS_UPDATED_SUCCESSFULLY") || "Statut mis à jour avec succès", {
        //   title: this.$t("SUCCESS") || "Succès",
        //   variant: "success",
        //   solid: true,
        //   autoHideDelay: 2000,
        // });
      } catch (error) {
        console.error("Error updating devis status:", error);
        // Revert selectedStatus to previous value
        this.selectedStatus = previousStatus;
        this.$bvToast.toast(
          error.response?.data?.message || this.$t("ERROR_UPDATING_STATUS") || "Erreur lors de la mise à jour du statut",
          {
            title: this.$t("ERROR") || "Erreur",
            variant: "danger",
            solid: true,
            autoHideDelay: 5000,
          }
        );
      } finally {
        this.statusUpdateLoading = false;
      }
    },
    async getPaiement(devis_ID) {
      try {
        const response = await axios.get(domain + `/devis_moyens_paiement`, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
          params: {
            devis_id: devis_ID,
          },
        });

        const data = response.data.data;

        const uniqueMoyensPaiement = new Set(data);

        return Array.from(uniqueMoyensPaiement);
      } catch (error) {
        throw new Error(
          error.response?.data?.message ||
            "An error occurred while fetching the payment information."
        );
      }
    },
    formatDate(date) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY");
    },
    formatDecimal(value, decimals = 3) {
      if (value === null || value === undefined || isNaN(value)) {
        return '0.000';
      }
      return parseFloat(value).toFixed(decimals);
    },
    formatPhoneFixe(telFixe) {
      if (!telFixe) return '';
      if (typeof telFixe === 'string') return telFixe;
      
      const prefix = (telFixe.prefix || '').trim();
      const phoneNumber = (telFixe.phone_number || '').trim();
      const isoCode = telFixe.phone_iso_code || telFixe.iso_code || '';
      
      // Si le prefix commence déjà par +, il contient déjà le code ISO
      if (prefix && prefix.startsWith('+')) {
        return `${prefix} ${phoneNumber}`;
      }
      
      // Sinon, utiliser le code ISO si disponible
      if (isoCode) {
        // Si le code ISO est déjà formaté avec +, l'utiliser directement
        if (isoCode.startsWith('+')) {
          return `${isoCode} ${prefix} ${phoneNumber}`.trim();
        }
        // Si le code ISO est un code pays (2 lettres), on ne peut pas le convertir sans table
        // Mais on peut vérifier si le prefix contient déjà un indicatif
        // Pour l'instant, on affiche le prefix tel quel s'il existe, sinon on utilise le code ISO
        if (prefix) {
          // Si le prefix existe mais ne commence pas par +, on l'affiche tel quel
          return `${prefix} ${phoneNumber}`.trim();
        }
        // Si pas de prefix, on affiche juste le code ISO et le numéro
        return `${isoCode} ${phoneNumber}`.trim();
      }
      
      // Si pas de code ISO, afficher juste prefix et numéro
      return `${prefix} ${phoneNumber}`.trim();
    },
    formatClientType(type) {
      if (!type) return '';
      // Enlever le préfixe "type." si présent
      return type.replace(/^type\./, '');
    },
    async handleRouteChange() {
      const id = this.$route.params.id;

      if (id) {
        this.editLoader = true;
        await this.fetchDevisObject(id);

        if (this.devisObject && Object.keys(this.devisObject).length > 0) {
          this.editLoader = false;
        } else {
          this.editLoader = true;
        }
      } else {
        this.loadSavedDevisObject();
        if (this.devisObject && Object.keys(this.devisObject).length > 0) {
          this.editLoader = false;
        } else {
          this.editLoader = true;
        }
      }
    },
  },
  async created() {
    this.editLoader = true;
    this.handleRouteChange();
    const devi_ID = this.$route.params.id;

    const data = await this.getPaiement(devi_ID);
    this.moyens_paiement = data.filter(
      (item, index, self) =>
        self.findIndex((t) => t.moyen_paiement === item.moyen_paiement) ===
        index
    );
    // this.moyens_paiement = data;
  },
};
</script>
<style lang="scss" scoped>
::v-deep .facture-modal-title {
  font-size: 1.5rem;
  font-weight: 600;
}

::v-deep .facture-modal-dialog .modal-content {
  min-height: 40vh;
}

::v-deep .facture-modal-body {
  display: flex;
  flex-direction: column;
  height: 100%;
}

::v-deep .facture-modal-body .facture-modal-actions {
  margin-top: auto;
}
.colorWhite {
  color: white;
}
.profil-placeholder {
  width: 100px;
  height: 100px;
  background-color: #28367a;
  color: white;
  border-radius: 8px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image {
  display: flex;
  align-items: center;
  justify-content: center;
  .colorText {
    color: white;
  }
  .profil {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 120px;
    border-radius: 5%;
    background-color: #28367a;
    color: #fff;
    font-size: 58px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
/* Ligne Description */
.table td {
  width: 6%;
}

.table td.descblock {
  width: 84%;
  word-wrap: break-word;
}

.bord {
  border-top: 1px solid #cf0a0a;
}
.color {
  background-color: #f8f9fa !important;
  border: none !important;
  color: #28367a !important;
  // border-top: 3px solid #6472b3;
}

.wImag {
  width: 65%;
  height: 55%;
}
.descblock {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.truncated-desc {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.read-toggle {
  color: blue;
  cursor: pointer;
  margin-left: 5px;
}

.custom-dropdown .dropdown-menu {
  box-shadow: none !important;
  margin-right: 50px;
  left: auto;
  right: 0;
}
.dropdown-menu.show {
  display: block;
  margin-right: 120px;
}
.loding {
  height: 100% !important;
}
.brouillon {
  border-radius: 25px;
}
.status-badge {
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
  min-width: 100px;
  text-align: center;
  &.clickable-status {
    &:hover {
      opacity: 0.8;
      transform: scale(1.05);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
    &:active {
      transform: scale(0.98);
    }
  }
  &.disabled-status {
    cursor: not-allowed;
    opacity: 0.6;
  }
  &.status-readonly {
    cursor: default;
    pointer-events: none;
  }
}
.bg-color {
  border-radius: 5px;

  background-color: white;
}
div {
  font-size: 13px;
}
.divborder {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  overflow: hidden;
  color: #28367a;
  width: 100%;
}
.divborder::after,
.divborder::before {
  content: "";
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
  height: 2px;
  background-color: #000000;
}

.justify {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
b {
  color: #28367a;
}
.red {
  font-weight: bold;
  color: #e4261a;
}
.part {
  padding: 8px 0;
  span {
    font-size: 14px;
    font-weight: 500;
    color: white;
    word-wrap: break-word;
  }
  .ml {
    margin-left: 500px;
  }
  .cadre {
    background-color: #f8f8f8;
    margin-top: 1%;
    margin-bottom: 1%;
    box-shadow: 0 2px 6px rgb(0 0 0 / 10%);
    padding: 13px;
    height: 350px;
  }
  .left {
    @media only screen and (max-width: 1000px) {
      width: 100%;
    }
    width: 30%;
  }

  .right {
    @media only screen and (max-width: 1000px) {
      width: 100%;
    }
    width: 23%;
    p {
      float: right;
      padding: 8px;
      background-color: #d0cccc;
      color: #000;
      width: 50%;
      font-weight: 600;
      text-align: center;
      margin: 0 0 4px;
    }
  }

  .part-title {
    color: #28367a;
    font-weight: 700;
    margin-right: 10px;
  }

  ul {
    list-style: none;

    li {
      @media only screen and (max-width: 1000px) {
        justify-content: space-between;
      }
      display: flex;
      align-items: center;
      color: #515151;

      span {
        display: block;
        width: 174px;
        font-size: 14px;
        white-space: nowrap;
      }

      .title {
        @media only screen and (max-width: 900px) {
          font-size: 12px;
        }
        color: #393939;
        font-weight: 600;
        font-size: 14px;
        margin-right: 10px;
      }
    }

    .traveauxtitle {
      @media only screen and (max-width: 900px) {
        padding: 0;
      }
      padding: 0 15px;
    }
  }
  .half-width {
    flex: 0 0 25%;
  }
  .flexEnd {
    display: flex;
    justify-content: space-between;
    .sousTraitant {
      p {
        color: #2167d9;
      }
    }
    .subtable {
      .complet {
        @media only screen and (max-width: 1000px) {
          margin-right: 10%;
          width: 100%;
        }
        border-collapse: separate;
        margin-right: 10%;
        width: 100%;
        height: 32px;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        tr {
          height: 24px;
        }

        .thead {
          @media only screen and (max-width: 1000px) {
            padding: 6px !important;
          }
          background-color: #6472b3;
          color: #fff;
          max-width: 118px;
          height: 32px;
        }
        td {
          color: #000;
          background-color: #e9eaf2;
          width: 118px;
        }
      }
    }
  }
  .tabledonne {
    overflow-x: auto;
    margin-bottom: 4px;
    .table td {
      width: 6%;
    }

    .table td.descblock {
      width: 84%;
      word-wrap: break-word;
    }
  }
  // table {
  //   padding-left: 6px;
  //   padding-right: 4px;
  //   margin: 14px 0;
  //   border-collapse: separate;
  //   th {
  //     font-weight: 400;
  //     font-size: 12px;
  //     background-color: #6472b3;
  //     padding: 4px;
  //     color: #fff;
  //     border: 1px solid #6472b3;
  //     text-align: center;
  //   }
  //   td {
  //     text-align: center;
  //     padding: 4px;
  //     background-color: #e9eaf2;
  //     .libblock {
  //       font-weight: 800;
  //       white-space: nowrap;
  //       overflow: hidden;
  //       text-overflow: ellipsis;
  //     }
  //   }
  //   // tr {
  //   //   height: 24px;
  //   // }
  // }
}
.spinner-border {
  width: 1.2rem;
  height: 1.2rem;
}
.groupEdit {
  border: 1px solid #707070;
  padding: 8px;
  border-radius: 5px;
  margin-bottom: 16px;
  box-shadow: 0 0 2px 0 #707070;

  .entete {
    font-weight: 400;
    font-size: 12px;
    background-color: #28367a;
    padding: 4px;
    color: #fff;
    text-align: center;
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
  }
  .action {
    display: flex;
    align-content: center;
    .trash,
    .ajout {
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 6px;
      color: #fff;
      height: 30px;
      width: 40%;
      margin: auto auto 15px auto;
    }
    .trash {
      background-color: #e4261a;
    }
  }
}

.textstyle {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.inner-container .page-header button {
  margin-bottom: 0 !important;
  color: #fff;
  width: 0% !important;
  height: 43px;
}
.dropdown-btn {
  background-color: #28367a;
  text-align: center;
  padding: 10px 80px;
  margin-left: 20px;
  margin-right: 12px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}
.title {
  font-size: 18px;
  font-weight: 800;
  border: none;
  border-radius: 5px;
  box-shadow: 1px 1px 4px 0px #15223214;
}
.bg-color-gray {
  background-color: #e9eaf25b;
}
.dropdown-content {
  cursor: pointer;
  display: none;
  position: absolute;
  top: 100%; /* Juste en dessous du bouton */
  left: 50%; /* Centre horizontalement par rapport au bouton */
  transform: translateX(-50%); /* Centre exactement le menu */
  background-color: #f9f9f9;
  min-width: 200px; /* Largeur minimale du menu */
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.dropdown-content a {
  text-align: center;
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.sort-arrow {
  cursor: pointer;
  color: grey;
  padding: 0 5px;
  font-size: 14px;
}

.sort-arrow:hover {
  color: white;
}

.active-sort {
  color: white;
  font-weight: bold;
}

.piece {
  // background-color: #;
  font-weight: bold;
  color: #28367a;
  padding: 0px 15px;
  border-radius: 5px 5px 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div:first-child {
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  p {
    margin: 0;
    font-size: 14px;
    margin-right: 8px;
    overflow: hidden;
  }
  .icone-down-up {
    display: flex;
    align-items: center;
    p,
    span {
      @media only screen and (max-width: 1000px) {
        display: none;
      }
    }

    button {
      background-color: transparent !important;
      border: transparent;
      box-shadow: none;
    }

    span {
      font-size: 14px;
      background-color: #6472b3;
      border-radius: 4px;
      padding: 2px 12px;
    }
  }
}

.group_financement {
  width: 100%;
  padding: 8px 12px;
  background-color: #eef1fd;
  border-radius: 5px;
}
.svg-inline--fa {
  margin: inherit;
}
.grey {
  background-color: #f5f6f8;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  margin: 0 auto;
}

form .form-group {
  max-width: none !important;
}

.desclass {
  margin-top: 9px;
}
.cours {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  p {
    margin: 0;
    color: #fff;
    background-color: #d0cccc;
    width: 81px;
    height: 24px;
    font-size: 13px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  button {
    font-size: 14px;
  }
}
.content {
  .content-header {
    .input-group {
      @media only screen and (max-width: 1000px) {
        width: 59%;
      }
      width: 80%;
      position: relative;
      margin-bottom: 0;
      .icon-search {
        @media only screen and (max-width: 1000px) {
          display: none;
        }
        overflow: visible;
        position: absolute;
        left: 15px;
        top: 10px;
        color: #515151;
      }

      .icon-balance {
        cursor: pointer;
        overflow: visible;
        position: absolute;
        right: 15px;
        top: 10px;
        color: #28367a;
        outline: 0;

        .balance {
          color: #28367a;
        }
      }
      .form-control::placeholder {
        color: #515151;
        font-size: 12px;
      }
    }

    .filtre {
      @media only screen and (max-width: 1000px) {
        width: 39%;
      }
      width: 19%;
      background-color: #28367a;
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 8px 4px;
      border-radius: 5px;
      font-size: 12px;
    }
  }

  & p {
    font-size: 12px;
    font-weight: 500;
    margin: 8px 15px 0 0;
  }
}

.body {
  padding: 15px;
  box-shadow: 1px 1px 24px #00000019;
  max-height: 60vh;
  overflow: auto;

  ul {
    list-style: none;
    & li {
      padding: 8px 0;
      cursor: pointer;
      background-color: #f8f8f8;
      margin-bottom: 4px;
      color: #000;
      border: none;
      box-shadow: none;
      transition: all 0.2s ease;
      text-align: center;

      &:hover {
        background-color: #28367a;
        color: #fff;
      }
    }
  }
}

.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

body {
  background: #fafdff;
}
.justify {
  padding: 13px;
  .left {
    h2 {
      color: #28367a;
      font-weight: 700;
      margin-bottom: 0px;
    }
    .entrepriseinfo {
      color: #000;
      font-weight: 600;
    }
    .title {
      color: #28367a;
      font-weight: 700;
    }
    .adressinfo {
      display: grid;
    }
    .info {
      color: #515151;
    }
    .block {
      margin-top: 10px;
    }
  }
  .right {
    .span {
      color: #515151;
    }
    h2 {
      color: #28367a;
      font-weight: 700;
    }
    .adressinfo {
      display: grid;
    }
    .info {
      color: #515151;
    }
    .entrepriseinfo {
      color: #000;
      font-weight: 600;
    }
  }
}

.divborder {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  overflow: hidden;
  color: #28367a;
  width: 100%;
  p {
    margin: 0px 10px;
  }
}
.divborder::after,
.divborder::before {
  content: "";
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
  height: 1px;
  background-color: #d8d8d8;
}
.part .table td.blocklibdesc {
  text-align: left;

  .descblock {
    white-space: normal;
    max-width: 400px;
    height: 72px;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.575;
    position: relative;
  }
  .read {
    bottom: -2px;
    right: 0;
    display: inline-block;
    font-size: 12px;
    font-weight: 800;
    color: #28367a;
  }
}

.detailClient {
  background-color: #fff;
  box-shadow: 1px 1px 24px #00000019;
  .clientTop {
    padding: 16px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border-bottom: 1px solid #707070;

    & .prodimg {
      max-width: 185px;
      max-height: 231px;
    }

    .star {
      color: #ffc400;
      position: absolute;
      top: 12px;
      right: 8px;
      font-size: 30px;
    }
  }

  .clientMid {
    padding: 16px 8px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-bottom: 1px solid #707070;
    & > div {
      width: 50%;
    }
  }

  .clientBot {
    padding: 16px 8px;
  }

  & h4 {
    color: #28367a;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }

  & p {
    color: #515151;
    font-size: 16px;
    font-weight: 500;
  }
}
.filtre {
  display: flex;
  align-items: center;
  gap: 6px;

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;
    margin: 2px 0 !important;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}

.justify {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.part {
  padding: 0px;
  /* padding: 8px 0; */
  span {
    font-size: 14px;
    font-weight: 500;
    color: #515151;
    word-wrap: break-word;
  }
  .remarqueblock {
    margin-bottom: 5px;
  }
  .cadre {
    background-color: #f8f8f8;
    margin-top: 1%;
    margin-bottom: 1%;
    box-shadow: 0 2px 6px rgb(0 0 0 / 10%);
    padding: 13px;
  }
  .left {
    @media only screen and (max-width: 1000px) {
      width: 100%;
    }
    width: 30%;
  }

  .right {
    @media only screen and (max-width: 1000px) {
      width: 100%;
    }
    width: 23%;
    p {
      float: right;
      padding: 8px;
      background-color: #d0cccc;
      color: #000;
      width: 50%;
      font-weight: 600;
      text-align: center;
      margin: 0 0 4px;
    }
  }

  .fact {
    font-size: 16px;
    color: #28367a;
  }

  h2,
  h3 {
    font-weight: 600;
  }

  h2 {
    font-size: 16px;
  }
  h3 {
    color: #515151;
    font-size: 16px;
    margin: 0;
  }

  ul {
    list-style: none;

    li {
      @media only screen and (max-width: 1000px) {
        justify-content: space-between;
      }
      display: flex;
      align-items: center;
      color: #515151;

      span {
        display: block;
        width: 174px;
        font-size: 14px;
        white-space: nowrap;
      }

      .title {
        @media only screen and (max-width: 900px) {
          font-size: 12px;
        }
        color: #393939;
        font-weight: 600;
        font-size: 14px;
        margin-right: 10px;
      }
    }

    .traveauxtitle {
      @media only screen and (max-width: 900px) {
        padding: 0;
      }
      padding: 0 15px;
    }
  }
  .flexEnd {
    display: flex;
    justify-content: space-between;
    .sousTraitant {
      p {
        color: #2167d9;
      }
    }
    .subtable {
      .complet {
        @media only screen and (max-width: 1000px) {
          margin-right: 10%;
          width: 100%;
        }
        border-collapse: separate;
        margin-right: 10%;
        width: 100%;
        height: 32px;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        tr {
          height: 24px;
        }

        .thead {
          @media only screen and (max-width: 1000px) {
            padding: 6px !important;
          }
          background-color: #6472b3;
          color: #fff;
          max-width: 118px;
          height: 32px;
        }
        td {
          color: #000;
          background-color: #e9eaf2;
          width: 118px;
        }
      }
    }
  }
  .tabledonne {
    overflow-x: auto;
    margin-bottom: 4px;
  }
  table {
    border-collapse: separate;
    th {
      font-weight: 400;
      font-size: 12px;
      background-color: #6472b3;
      padding: 4px;
      color: #fff;
      border: 1px solid #6472b3;
      text-align: center;
    }
    td {
      text-align: center;
      padding: 4px;
      background-color: #e9eaf2;
      .libblock {
        font-weight: 800;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    tr {
      height: 24px;
    }
  }
}
.group {
  @media only screen and (max-width: 1000px) {
    overflow: hidden;
    padding: 8px;
  }
  box-shadow: 0px 2px 6px #00000019;
  background-color: #fff;
  border-radius: 0 0 5px 5px;
  margin-bottom: 15px;
  .part {
    overflow: auto;
    padding: 15px;
    margin-bottom: 0;
  }
}

.flexEndTotale {
  display: flex;
  justify-content: flex-end;
  .subtableTotale {
    .completTotale {
      @media only screen and (max-width: 1000px) {
        margin-right: 10%;
        width: 100%;
      }
      border-collapse: separate;
      margin-right: 10%;
      width: 100%;
      height: 32px;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      tr {
        height: 24px;
      }

      .theadTotale {
        @media only screen and (max-width: 1000px) {
          padding: 6px !important;
        }
        background-color: #28367a;
        color: #fff;
        max-width: 118px;
        height: 32px;
      }
      td {
        color: #000;
        background-color: #e9eaf2;
        width: 135px;
      }
    }
  }
}
.textstyle {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

div {
  font-size: 13px;
}
.divborder {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  overflow: hidden;
  color: #28367a;
  width: 100%;
  height: 3px;
}

.divborder::after,
.divborder::before {
  content: "";
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
  height: 2px;
  background-color: #000000;
}

.justify {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.brouillon {
  border-radius: 25px;
}
b {
  color: #28367a;
}
.red {
  font-weight: bold;
  color: #e4261a;
}
.part {
  /* padding: 8px 0; */
  span {
    font-size: 14px;
    font-weight: 500;
    color: #515151;
    word-wrap: break-word;
  }

  .cadre {
    background-color: #f8f8f8;
    margin-top: 1%;
    margin-bottom: 1%;
    box-shadow: 0 2px 6px rgb(0 0 0 / 10%);
    padding: 13px;
    height: 350px;
  }
  .left {
    @media only screen and (max-width: 1000px) {
      width: 100%;
    }
    width: 30%;
  }

  .right {
    @media only screen and (max-width: 1000px) {
      width: 100%;
    }
    width: 23%;
    p {
      float: right;
      padding: 8px;
      background-color: #d0cccc;
      color: #000;
      width: 50%;
      font-weight: 600;
      text-align: center;
      margin: 0 0 4px;
    }
  }

  ul {
    list-style: none;

    li {
      @media only screen and (max-width: 1000px) {
        justify-content: space-between;
      }
      display: flex;
      align-items: center;
      color: #515151;

      span {
        display: block;
        width: 174px;
        font-size: 14px;
        white-space: nowrap;
      }

      .title {
        @media only screen and (max-width: 900px) {
          font-size: 12px;
        }
        color: #393939;
        font-weight: 600;
        font-size: 14px;
        margin-right: 10px;
      }
    }

    .traveauxtitle {
      @media only screen and (max-width: 900px) {
        padding: 0;
      }
      padding: 0 15px;
    }
  }
  .half-width {
    flex: 0 0 25%;
  }
  .flexEnd {
    display: flex;
    justify-content: space-between;
    .sousTraitant {
      p {
        color: #2167d9;
      }
    }
    .subtable {
      .complet {
        @media only screen and (max-width: 1000px) {
          margin-right: 10%;
          width: 100%;
        }
        border-collapse: separate;
        margin-right: 10%;
        width: 100%;
        height: 32px;
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        tr {
          height: 24px;
        }

        .thead {
          @media only screen and (max-width: 1000px) {
            padding: 6px !important;
          }
          background-color: #6472b3;
          color: #fff;
          max-width: 118px;
          height: 32px;
        }
        td {
          color: #000;
          background-color: #e9eaf2;
          width: 118px;
        }
      }
    }
  }
  .tabledonne {
    overflow-x: auto;
    margin-bottom: 4px;
  }
  table {
    border-collapse: separate;
    th {
      font-weight: 400;
      font-size: 12px;
      background-color: #6472b3;
      padding: 4px;
      color: #fff;
      border: 1px solid #6472b3;
      text-align: center;
    }
    td {
      text-align: center;
      padding: 4px;
      background-color: #e9eaf2;
      .libblock {
        font-weight: 800;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    tr {
      height: 24px;
    }
  }
}
.spinner-border {
  width: 1.2rem;
  height: 1.2rem;
}
.groupEdit {
  border: 1px solid #707070;
  padding: 8px;
  border-radius: 5px;
  margin-bottom: 16px;
  box-shadow: 0 0 2px 0 #707070;

  .entete {
    font-weight: 400;
    font-size: 12px;
    background-color: #28367a;
    padding: 4px;
    color: #fff;
    text-align: center;
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
  }
  .action {
    display: flex;
    align-content: center;
    .trash,
    .ajout {
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 6px;
      color: #fff;
      height: 30px;
      width: 40%;
      margin: auto auto 15px auto;
    }
    .trash {
      background-color: #e4261a;
    }
  }
}

.textstyle {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
